// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:36:03.358Z
// Property: Ember at Alamo Ranch (ID: 5719836663480320)
// Collections: 8 amenities, 4 floorplans (live), 17 photos, 85 POIs, 3 reviews, 1 virtual tours, 6 office hours, 1 special offers (live), 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5719836663480320",
  "property_external_id": "4981186",
  "property_zillow_url": "https://www.zillow.com/b/ember-at-alamo-ranch-san-antonio-tx-5Xj5Xj/",
  "property_apartments_url": "https://www.apartments.com/ember-at-alamo-ranch-san-antonio-tx/yq4rnzr",
  "property_google_business_url": "https://www.google.com/maps/place/Meadow+Creek+Apartment+homes/@29.4956923,-98.7149821,17z/data=!3m1!4b1!4m5!3m4!1s0x865c427a4aef86ad:0x73333b943ce1e1c9!8m2!3d29.495685!4d-98.7127976",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443881655",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "ember-at-alamo-ranch",
  "property_name": "Ember at Alamo Ranch",
  "property_website_url": "https://www.emberatalamoranch.com/",
  "property_domain": "https://www.emberatalamoranch.com/",
  "property_address": "11022 Culebra Rd",
  "property_full_address": "11022 Culebra Rd, San Antonio, TX 78253",
  "property_address_1": "11022 Culebra Rd",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "TX",
  "property_address_zip_full": "78253-6497",
  "property_address_zip": "78253",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Far West Side",
  "property_address_latitude": "29.49497019999999",
  "property_address_longitude": "-98.7128649",
  "property_email": "ember@alapts.com",
  "property_phone": "(210) 688-0380",
  "property_call_tracking_phone": "361-213-9260",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Far West Side living starts here.</strong> Explore one- and two-bedroom apartments with hardwood-style flooring, walk-in closets, and select upgraded finishes, all with everyday convenience near Culebra Road—then schedule your tour at Ember at Alamo Ranch.</p>",
  "property_long_description": "<p><strong>Modern Far West Side living with Alamo Ranch convenience.</strong> At Ember at Alamo Ranch, you’re close to the everyday energy of Culebra Road while still having room to recharge. Choose from streamlined one- and two-bedroom <a href=\"/floor-plans\">apartment layouts</a> with practical comforts like hardwood-style flooring, walk-in closets, high-speed internet access, washer/dryer connections, and select upgraded finishes such as granite countertops, stainless steel appliances, decorative tile backsplashes, bay windows, and USB outlets.</p><p>Outside your door, the community adds a <a href=\"/amenities\">resort-inspired pool</a>, fitness center, clubhouse, controlled access, storage options, EV charging, online resident services, and the American Landmark 360 Program—plus a wooded jogging trail that brings a quieter edge to daily routines. When you head out, you’re moments from Alamo Ranch Square, Westwood Center, Culebra Point, Loop 1604, and Highway 151, with SeaWorld San Antonio, Government Canyon State Natural Area, Northwest Vista College, and the wider <a href=\"/neighborhood\">Far West Side</a> dining and shopping scene within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019d02f2-c719-71c2-b581-3318b2c26a99.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a granite island with bar stools.",
    "public_id": "019d02f2-c719-71c2-b581-3318b2c26a99",
    "storage_key": "property/5719836663480320/019d02f2-c719-71c2-b581-3318b2c26a99.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "204",
  "property_year_built": "2015",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.19607843137256",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nApplication Approval Fee Startinga t $399\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $20 / pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $20 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8879186.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://emberatalamoranch.loftliving.com/login",
  "property_apply_now_url": "https://8879186.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e6a83-b96c-7526-98d6-ae37dfb2f31f.webp",
  "property_primary_logo_media": {
    "alt_text": "Ember at Alamo Ranch logo",
    "public_id": "019e6a83-b96c-7526-98d6-ae37dfb2f31f",
    "storage_key": "property/5719836663480320/019e6a83-b96c-7526-98d6-ae37dfb2f31f.webp",
    "width": 1341,
    "height": 646
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e6a84-253e-76d8-8fd4-6b0422e079ec.webp",
  "property_secondary_logo_media": {
    "alt_text": "Ember at Alamo Ranch Premier Apartments logo.",
    "public_id": "019e6a84-253e-76d8-8fd4-6b0422e079ec",
    "storage_key": "property/5719836663480320/019e6a84-253e-76d8-8fd4-6b0422e079ec.webp",
    "width": 1263,
    "height": 646
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e6a83-b5dc-7645-8c78-08a86cc1edc2.webp",
  "property_icon_media": {
    "alt_text": "Ember logo.",
    "public_id": "019e6a83-b5dc-7645-8c78-08a86cc1edc2",
    "storage_key": "property/5719836663480320/019e6a83-b5dc-7645-8c78-08a86cc1edc2.webp",
    "width": 1962,
    "height": 1963
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e6a83-b5dc-7645-8c78-08a86cc1edc2.webp",
  "property_fav_icon_media": {
    "alt_text": "Ember logo.",
    "public_id": "019e6a83-b5dc-7645-8c78-08a86cc1edc2",
    "storage_key": "property/5719836663480320/019e6a83-b5dc-7645-8c78-08a86cc1edc2.webp",
    "width": 1962,
    "height": 1963
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e6a83-b93f-7522-a783-42a7ec6c09fb.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Ember at Alamo Ranch Premier Apartments logo",
    "public_id": "019e6a83-b93f-7522-a783-42a7ec6c09fb",
    "storage_key": "property/5719836663480320/019e6a83-b93f-7522-a783-42a7ec6c09fb.webp",
    "width": 1263,
    "height": 646
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e6a83-b75e-76aa-8fb4-2f0936d55dfd.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Ember at Alamo Ranch logo",
    "public_id": "019e6a83-b75e-76aa-8fb4-2f0936d55dfd",
    "storage_key": "property/5719836663480320/019e6a83-b75e-76aa-8fb4-2f0936d55dfd.webp",
    "width": 1263,
    "height": 646
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#e04307",
  "property_font_color": "#2e2a25",
  "property_color_4": "#691b33",
  "property_color_3": "#fcb600",
  "property_color_5": "#bdbec0",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "499 - 937",
  "property_sqft_min": "499",
  "property_sqft_max": "937",
  "property_price_range": "980 - 1561",
  "property_price_min": "980",
  "property_price_max": "1561",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/emberatalamoranchapts",
  "property_instagram_url": "https://www.instagram.com/emberatalamoranch",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJrYbvSnpCXIYRyeHhPJQ7M3M",
  "property_youtube_url": "https://www.youtube.com/@EmberatAlamoRanch",
  "property_yelp_url": "https://www.yelp.com/biz/ember-alamo-ranch-san-antonio",
  "property_tiktok_url": "https://www.tiktok.com/@emberatalamoranchapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease, built in.</strong> Start with a lap along the wooded jogging trail, fit in time at the fitness center, then unwind by the pool or in the clubhouse. At Ember at Alamo Ranch, controlled access, available storage, and online resident services keep the details simple, so the community amenities feel as practical as they are relaxing.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans that fit the way each day moves.</strong> Explore one- and two-bedroom apartments at Ember at Alamo Ranch with practical layouts, walk-in closets, washer/dryer connections, and hardwood-style flooring. Select homes add polished upgrades like granite countertops, stainless steel appliances, decorative tile backsplashes, bay windows, and USB outlets—details that make each option worth a closer look.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Ember at Alamo Ranch.</strong> Preview bright interiors with hardwood-style flooring, streamlined kitchens, calm bedrooms, and balconies made for a breath of fresh air. Then look beyond the apartment: a sunlit pool, inviting clubhouse seating, fitness center, coffee bar, EV charging, and a wooded jogging trail all come into view. Browse the full gallery to see how everyday comfort connects across the community.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Far West Side convenience, with room to roam.</strong> Ember at Alamo Ranch puts Culebra Road essentials close, from groceries and coffee to casual dining and shopping in the Alamo Ranch retail corridor. Catch a night out at Santikos Casa Blanca, meet up near Alamo Ranch Parkway, or head toward Government Canyon State Natural Area for Hill Country trails—then come home to a wooded jogging trail and relaxed community spaces.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews tell the Ember story.</strong> Feedback frequently points to a responsive on-site team, including shoutouts for Jeanette, Jessica, and the maintenance crew. Residents also call out quick help with service requests, a clean community, a well-kept pool area, and thoughtful gatherings that make everyday life feel easier. Read the latest reviews to see why the team’s “above and beyond” care stands out.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a Far West Side routine with more built in.</strong> From Ember at Alamo Ranch, Culebra Road keeps daily stops close—groceries, coffee, casual dining, and shopping around the Alamo Ranch retail corridor—while nearby westside routes help you branch out across San Antonio. Plan a movie-and-bowling night at Santikos Casa Blanca, meet up for dinner near Alamo Ranch Parkway, or trade pavement for Hill Country scenery at Government Canyon State Natural Area, where miles of trails add a wilder counterpoint to the area’s steady growth.</p><p>Back at Ember, you can keep the neighborhood momentum going with a wooded jogging trail and relaxed community spaces. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that add ease to every day.</strong> At Ember at Alamo Ranch, your routine can move from a morning lap on the wooded jogging trail to a focused workout in the fitness center, then back to a relaxed afternoon by the pool. The clubhouse offers a comfortable place to pause between plans, while controlled access, storage options, and convenient online resident services help keep the practical side of apartment living simple.</p><p>Inside the community, details are designed to support a streamlined lifestyle without overcomplicating it. Explore the amenity spaces in the <a href=\"/gallery\">photo gallery</a>, compare one- and two-bedroom layouts on the <a href=\"/floor-plans\">floor plans</a> page, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Ember’s features fit into your day.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at Ember at Alamo Ranch.</strong> Choose a streamlined one- or two-bedroom layout with everyday comforts like hardwood-style flooring, walk-in closets, high-speed internet access, and washer/dryer connections. With online resident services and a Far West Side setting that balances convenience and recharge time, applying online is a simple next step.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the leasing team at Ember at Alamo Ranch for help exploring modern one- and two-bedroom apartment living near Culebra Road, from practical in-home comforts to community spaces designed for everyday ease.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Ember at Alamo Ranch?</strong> Start here for quick answers about leasing, community features, apartment living, and everyday details. If you need anything more specific, the leasing team is happy to help—just <a href=\"/contact-us\">reach out</a> when you’re ready.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that matches your rhythm.</strong> Ember at Alamo Ranch’s one- and two-bedroom apartment floor plans make it easy to compare the details that shape daily living: an efficient one-bedroom when you want a streamlined setup, a larger one-bedroom with more room to spread out, or a two-bedroom layout with two baths for added flexibility.</p><p>As you browse current pricing and availability, look for everyday comforts like hardwood-style flooring, walk-in closets, washer/dryer connections, high-speed internet access, and select upgraded finishes such as granite countertops, stainless steel appliances, decorative tile backsplashes, bay windows, and USB outlets. Want to see how each layout feels beyond the floor plan card? Explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to walk through your options in person.</p>",
  "property_gallery_blurb": "<p><strong>See Ember at Alamo Ranch from every angle.</strong> Browse photos that bring the community into focus: bright living rooms with hardwood-style flooring, kitchens with clean-lined cabinetry and select stainless steel appliances, bedrooms that feel calm and uncluttered, and balconies that add an easy outdoor moment to your day. The gallery also steps outside, from the sunlit pool and clubhouse seating to the fitness center, coffee bar, mail room, EV charging area, and wooded jogging trail. As you move through the images, picture how the one- and two-bedroom layouts connect everyday comfort with the community spaces around them. Then compare <a href=\"/floor-plans\">available floor plans</a>, explore more <a href=\"/amenities\">amenity details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Ember at Alamo Ranch in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Ember at Alamo Ranch on the map.</strong><br>Check available one- and two-bedroom apartments, then zoom out to see how Culebra Road, Loop 1604, Highway 151, nearby shopping, dining, and outdoor escapes connect to everyday life on San Antonio’s Far West Side.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with room to move.</strong> At Ember at Alamo Ranch, cats and dogs can settle in alongside you with a policy that welcomes up to two pets per home and does not set a weight limit. Start the day with a loop on the wooded jogging trail, keep leashes and carriers handy with practical storage options, and enjoy simple resident services that make everyday apartment life easier.</p><p>Beyond the community, the Culebra corridor puts pet-care essentials within reach, from veterinary visits to grooming and supplies, while nearby park paths add variety when it is time for a longer walk. Explore our <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Ember supports your daily routine with pets.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Ember at Alamo Ranch experience.</strong> If you love modern Far West Side living, streamlined one- and two-bedroom layouts, and everyday convenience near Culebra Road, invite a friend to take a look. Use the referral form below to send them our way.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Ember at Alamo Ranch.</strong><br>Make daily living simpler with online resident services. Log in to pay rent, submit maintenance requests, and manage your account—then get back to enjoying modern Far West Side living with Alamo Ranch convenience.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback from the people who call Ember at Alamo Ranch home.</strong> Reviews often highlight the care and responsiveness of the on-site team, with shoutouts to Jeanette, Jessica, and the maintenance crew for being helpful, professional, and easy to work with.</p><p>You’ll see residents praise prompt support with questions and maintenance requests, a clean community, a well-kept pool area, and thoughtful resident gatherings. One review says the team “goes above and beyond,” and that spirit comes through in the stories shared here. Explore the latest ratings and see what everyday living at Ember is like from a resident point of view.</p>",
  "property_created_at": "1743797426055",
  "property_scheduletour_blurb": "<p><strong>See modern Far West Side living up close.</strong><br>Tour Ember at Alamo Ranch to explore streamlined one- and two-bedroom layouts, hardwood-style flooring, walk-in closets, select upgraded finishes, and a resort-inspired pool with a wooded jogging trail nearby. Schedule your visit and picture daily life just off Culebra Road.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture modern Far West Side living with streamlined one- and two-bedroom layouts, practical in-home comforts, and space to recharge near the everyday convenience of Alamo Ranch.</p>",
  "property_virtualtours_blurb": "<p><strong>Step into Ember before you arrive.</strong> The Ember at Alamo Ranch Community Tour lets you get a feel for the shared spaces that shape daily life here, from relaxed clubhouse areas to outdoor moments around the pool and paths through the community. Move at your own pace, pause where you want a closer look, and picture how the fitness center, gathering spaces, and everyday conveniences connect just beyond your front door.</p><p>Use the virtual tour as your first walk-through, then keep exploring with the <a href=\"/gallery\">photo gallery</a> or compare one- and two-bedroom options on the <a href=\"/floor-plans\">floor plans page</a>. When you are ready to see more in person, <a href=\"/schedule-a-tour\">schedule a tour</a> with the leasing team.</p>",
  "property_copyright": "2025 All Rights Reserved. Ember at Alamo Ranch",
  "property_seo_title_home": "Ember at Alamo Ranch | Apartments in San Antonio, TX",
  "property_seo_description_home": "Experience modern living at Ember at Alamo Ranch! Enjoy spacious one and two-bedroom apartments with premium amenities like a pool, fitness center, and dog park.",
  "property_seo_title_floorplans": "Unlock your ideal lifestyle at Ember at Alamo Ranch in San Antonio, TX. Check out our one and two-bedroom floor plans tailored for your comfort!",
  "property_seo_description_floorplans": "\"Find your ideal home at Ember at Alamo Ranch in San Antonio, TX. Choose from stylish one or two-bedroom floor plans that fit your lifestyle perfectly!\"",
  "property_seo_title_amenities": "Amenities | San Antonio, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at Ember at Alamo Ranch! From a refreshing pool to a dog park, our community offers top-notch amenities tailored for your lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in San Antonio, TX",
  "property_seo_description_gallery": "\"Picture your life at Ember at Alamo Ranch, where modern design meets luxury amenities. Dive into our photo gallery and envision your dream home in San Antonio.\"",
  "property_seo_title_virtualtours": "Virtual Tours | Ember at Alamo Ranch Apartments",
  "property_seo_description_virtualtours": "Experience the warmth of Ember at Alamo Ranch in San Antonio, TX. Take a virtual tour to find your perfect one or two-bedroom apartment today!",
  "property_seo_title_interactivemap": "Interactive Map | Ember at Alamo Ranch Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Ember at Alamo Ranch in San Antonio, TX. From spacious layouts to top-notch amenities, your ideal apartment awaits! Explore now!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Antonio, TX",
  "property_seo_description_neighborhood": "Uncover the charm of Ember at Alamo Ranch in San Antonio, TX. Dive into local favorites and hidden gems just steps from your new one or two-bedroom home!",
  "property_seo_title_contact": "Contact Us | Ember at Alamo Ranch",
  "property_seo_description_contact": "Connect with Ember at Alamo Ranch in San Antonio, TX! Explore our one and two-bedroom floor plans and get answers to your leasing questions today!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, TX",
  "property_seo_description_faqs": "Get the answers you need about life at Ember at Alamo Ranch! Explore our FAQs to discover amenities, floor plans, and what makes our community shine in San Antonio.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, TX",
  "property_seo_description_reviews": "Experience vibrant living at Ember at Alamo Ranch! See what residents love about our amenities, from a sparkling pool to pet-friendly spaces, in sunny San Antonio.",
  "property_seo_title_applynow": "Apply Now | Apartments in San Antonio, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Ember at Alamo Ranch in San Antonio! Enjoy modern one and two-bedroom apartments with exceptional amenities. Apply now for your new home!",
  "property_seo_title_residentaccess": "Resident Access | Ember at Alamo Ranch",
  "property_seo_description_residentaccess": "\"Unlock convenience at Ember at Alamo Ranch! Access your resident portal to pay rent, schedule maintenance, and enjoy all your community offers!\"",
  "property_seo_title_referafriend": "Refer A Friend | Ember at Alamo Ranch",
  "property_seo_description_referafriend": "Spread the joy of community! Refer a friend to Ember at Alamo Ranch in San Antonio and enjoy perks together. Great friends, great neighbors await!",
  "property_seo_title_scheduletour": "Schedule a Tour | Ember at Alamo Ranch",
  "property_seo_description_scheduletour": "Experience vibrant living at Ember at Alamo Ranch in San Antonio. Schedule your tour today and envision your new home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Ember at Alamo Ranch",
  "property_seo_description_privacy": "Safeguarding your peace of mind at Ember at Alamo Ranch. Learn how we protect your privacy and keep your personal information secure. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Ember at Alamo Ranch",
  "property_seo_description_accessibility": "Experience seamless living at Ember at Alamo Ranch—where accessibility meets comfort in San Antonio. Join our commitment to digital inclusion today!",
  "property_seo_title_sitemap": "Sitemap | Ember at Alamo Ranch",
  "property_seo_description_sitemap": "Unlock the layout of your next home at Ember at Alamo Ranch. See our sitemap and find the perfect space in beautiful San Antonio, TX!",
  "property_seo_title_thankyou": "Thank You | Ember at Alamo Ranch",
  "property_seo_description_thankyou": "Thank you for reaching out to Ember at Alamo Ranch! A team member will connect with you soon to help you find your ideal San Antonio home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Summerville, SC\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319777",
  "amenities": [
    {
      "id": "custom_b2a3e370-72ea-448d-b8b2-11270d1be6a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "external_id": "false",
      "title": "Wooded Jogging Trail",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0189dd48-3391-44b1-ae3e-c51fc03b4e6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f33bbcbd-2cd6-4e30-8d3f-d5f01e82166a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7927e412-99ab-4a87-b19b-67972e33777e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bda2ee1f-08dc-40f0-9adb-c46c61d35bed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee82e874-720a-46b3-ba2b-193e7f3a7d6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ea93107-0383-45e3-b121-76efc5c2e9b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Online Resident Services",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_667b7b41-563b-4d27-b064-cb59b89325de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "external_id": "false",
      "title": "American Landmark 360 Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_80cf5027-3337-45fa-967a-f12d9f5eca3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8995-16dc-75d7-abe0-8c9e7b546bf1.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019e8995-16dc-75d7-abe0-8c9e7b546bf1",
        "storage_key": "property/5719836663480320/019e8995-16dc-75d7-abe0-8c9e7b546bf1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f02844ac-e061-421a-bf31-f022c3db892c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8995-14bc-7203-91d2-289ab38af674.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed and modern decor.",
        "public_id": "019e8995-14bc-7203-91d2-289ab38af674",
        "storage_key": "property/5719836663480320/019e8995-14bc-7203-91d2-289ab38af674.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in our beautifully appointed bedrooms, featuring plush bedding and stylish accents.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2382bf78-ad78-4f9d-93d4-1d4584ccba9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8995-16b3-7281-bfb5-8576861da457.webp",
      "image_media": {
        "alt_text": "Package lockers with \"Ember at Alamo Ranch Premier Apartments\" branding.",
        "public_id": "019e8995-16b3-7281-bfb5-8576861da457",
        "storage_key": "property/5719836663480320/019e8995-16b3-7281-bfb5-8576861da457.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure package lockers are available for resident use, branded with the \"Ember at Alamo Ranch Premier Apartments\" logo.",
      "link": "",
      "alt_text": "Package lockers with \"Ember at Alamo Ranch Premier Apartments\" branding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_07d5fc7f-9125-4416-a635-808ad6b0527b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8995-14a5-763f-b2d6-57e9c0a891f8.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee tables, and a TV.",
        "public_id": "019e8995-14a5-763f-b2d6-57e9c0a891f8",
        "storage_key": "property/5719836663480320/019e8995-14a5-763f-b2d6-57e9c0a891f8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room with comfortable seating and modern decor, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee tables, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c0c5c7e3-b266-4964-b125-a8a5e3909d02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8995-10d3-779c-8f1f-1f5af23931c1.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019e8995-10d3-779c-8f1f-1f5af23931c1",
        "storage_key": "property/5719836663480320/019e8995-10d3-779c-8f1f-1f5af23931c1.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge seating and shaded areas perfect for relaxation.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a13ce36-693f-4184-9801-6c0cba76ac46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-f70b-776b-80d8-ab557ab2d7c2.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park area with trees and play equipment.",
        "public_id": "019e8994-f70b-776b-80d8-ab557ab2d7c2",
        "storage_key": "property/5719836663480320/019e8994-f70b-776b-80d8-ab557ab2d7c2.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and explore in a safe, designated area.",
      "link": "",
      "alt_text": "Fenced-in dog park area with trees and play equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c7ad57d-5764-4128-aeff-4285fb859b09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-fa90-779b-aa10-df1e5ffabe53.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel appliances, gray cabinets, and granite countertops.",
        "public_id": "019e8994-fa90-779b-aa10-df1e5ffabe53",
        "storage_key": "property/5719836663480320/019e8994-fa90-779b-aa10-df1e5ffabe53.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a breakfast bar with seating.",
      "link": "",
      "alt_text": "Modern apartment kitchen with stainless steel appliances, gray cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ef07f819-da4b-434d-b62c-5b8ec898f9a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-f42e-746a-ae17-70b300b4f3c6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark gray cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019e8994-f42e-746a-ae17-70b300b4f3c6",
        "storage_key": "property/5719836663480320/019e8994-f42e-746a-ae17-70b300b4f3c6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring dark gray cabinetry, stunning granite countertops, and a full suite of stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark gray cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d514a496-ea1c-4a00-b19b-259a2b75e3f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-f40a-74e7-ab83-28ed5a1c0949.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019e8994-f40a-74e7-ab83-28ed5a1c0949",
        "storage_key": "property/5719836663480320/019e8994-f40a-74e7-ab83-28ed5a1c0949.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sectional sofa, a stylish coffee table, and a TV with a nature scene.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29cffaf3-76a0-4ee7-867a-0eef4262934b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-f581-710f-8034-e211e331bf84.webp",
      "image_media": {
        "alt_text": "Modern living room with a large sectional sofa, fireplace, and kitchen in the background.",
        "public_id": "019e8994-f581-710f-8034-e211e331bf84",
        "storage_key": "property/5719836663480320/019e8994-f581-710f-8034-e211e331bf84.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable sectional sofa, decorative fireplace, and a glimpse of a well-appointed kitchen.",
      "link": "",
      "alt_text": "Modern living room with a large sectional sofa, fireplace, and kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_921b5994-0513-492f-a817-8b1de4f0cee7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-f37f-75ee-bf36-ee67bfb15704.webp",
      "image_media": {
        "alt_text": "A well-decorated bedroom with a queen-size bed, nightstand, dresser, and window.",
        "public_id": "019e8994-f37f-75ee-bf36-ee67bfb15704",
        "storage_key": "property/5719836663480320/019e8994-f37f-75ee-bf36-ee67bfb15704.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in comfort in this stylish bedroom, featuring a plush queen-size bed, ample storage, and a bright, airy ambiance. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "A well-decorated bedroom with a queen-size bed, nightstand, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b800e32-16af-431f-929a-69530d9c39b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-f364-76ff-9f6a-4bda64ed18e1.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations with SemaConnect branding outside apartment buildings.",
        "public_id": "019e8994-f364-76ff-9f6a-4bda64ed18e1",
        "storage_key": "property/5719836663480320/019e8994-f364-76ff-9f6a-4bda64ed18e1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations available for residents, featuring SemaConnect technology. Park and charge your electric car right at home.",
      "link": "",
      "alt_text": "Electric vehicle charging stations with SemaConnect branding outside apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d52e3ba-b4e8-423b-a345-e94676a3d0ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-f593-723c-b146-4804a7a2d541.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with multiple buildings, a pool, and landscaping under a clear blue sky.",
        "public_id": "019e8994-f593-723c-b146-4804a7a2d541",
        "storage_key": "property/5719836663480320/019e8994-f593-723c-b146-4804a7a2d541.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Discover resort-style living at this multifamily property, featuring a refreshing pool, well-maintained courtyards, and modern apartment buildings. Enjoy the amenities and beautiful surroundings.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with multiple buildings, a pool, and landscaping under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1dc59a5b-594d-4280-995a-4a1ae4a2d617",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-f5e4-729c-b667-93eb881be8f3.webp",
      "image_media": {
        "alt_text": "Modern lounge area with gray armchairs, a fireplace, and a coffee station.",
        "public_id": "019e8994-f5e4-729c-b667-93eb881be8f3",
        "storage_key": "property/5719836663480320/019e8994-f5e4-729c-b667-93eb881be8f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our stylish lounge area featuring comfortable seating, a cozy fireplace, and a convenient coffee station with complimentary Starbucks service.",
      "link": "",
      "alt_text": "Modern lounge area with gray armchairs, a fireplace, and a coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_138404a8-94b0-4ee7-87aa-c13777222806",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-f244-724b-aead-b4f2c683cabb.webp",
      "image_media": {
        "alt_text": "Ember Cafe with coffee station and seating area",
        "public_id": "019e8994-f244-724b-aead-b4f2c683cabb",
        "storage_key": "property/5719836663480320/019e8994-f244-724b-aead-b4f2c683cabb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at the Ember Cafe, a convenient amenity for residents.",
      "link": "",
      "alt_text": "Ember Cafe with coffee station and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7eda372-b12f-4621-a970-15112a674c7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-d971-7159-b0c2-48beb29562fb.webp",
      "image_media": {
        "alt_text": "Exterior view of a three-story apartment building with a parking lot in the foreground.",
        "public_id": "019e8994-d971-7159-b0c2-48beb29562fb",
        "storage_key": "property/5719836663480320/019e8994-d971-7159-b0c2-48beb29562fb.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building showcasing its architecture, balconies, and parking facilities.",
      "link": "",
      "alt_text": "Exterior view of a three-story apartment building with a parking lot in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4faa30b-e25c-4e8c-a0d4-9b195107eba2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019e8994-d73f-716b-8577-9676fb5d77e0.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower.",
        "public_id": "019e8994-d73f-716b-8577-9676fb5d77e0",
        "storage_key": "property/5719836663480320/019e8994-d73f-716b-8577-9676fb5d77e0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the clean and modern design of this apartment bathroom, featuring a spacious vanity, a toilet, and a bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_04ddc4cd3c1e014f35957b5d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Colombia Tierra Querida",
      "poi_type": "Restaurants",
      "poi_address": "11019 Culebra Rd #122, San Antonio, TX 78254, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-614a-76ba-b583-369d47749702.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-614a-76ba-b583-369d47749702",
        "storage_key": "property/5719836663480320/019f150b-614a-76ba-b583-369d47749702.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://colombiatierraqueridatx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9793060437061344473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colombia-tierra-querida",
      "poi_latitude": "29.4976894",
      "poi_longitude": "-98.7097861",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-677-2371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQUGcFwBDXIYR2Rz55pTw54c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "colombian_restaurant"
    },
    {
      "id": "ec_79d4352528436b5a796c12b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "10826 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-660a-758b-9e6b-e17eb1f59073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-660a-758b-9e6b-e17eb1f59073",
        "storage_key": "property/5719836663480320/019f150b-660a-758b-9e6b-e17eb1f59073.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/10648/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10058999341789397113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "29.49422",
      "poi_longitude": "-98.70694",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-688-0805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c09c-771a-b812-c8fcaf9a6d77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c09c-771a-b812-c8fcaf9a6d77",
        "storage_key": "property/5719836663480320/019f150b-c09c-771a-b812-c8fcaf9a6d77.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJL-kPaHxCXIYRecA-Q5u-mIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_d3486a70b08c2e9471d987f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Black Rock Coffee Bar",
      "poi_type": "Restaurants",
      "poi_address": "12030 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Contemporary coffee chain serving classic, specialty & iced espresso beverages, plus smoothies.",
      "poi_long_description": "Contemporary coffee chain serving classic, specialty & iced espresso beverages, plus smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-66cf-71dc-9adf-b1b649d40726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-66cf-71dc-9adf-b1b649d40726",
        "storage_key": "property/5719836663480320/019f150b-66cf-71dc-9adf-b1b649d40726.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "https://www.br.coffee/locations/culebra-alamo-pkwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=10280016185552052224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-rock-coffee-bar",
      "poi_latitude": "29.5028865",
      "poi_longitude": "-98.7296824",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 833-843-5776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c09c-771a-b812-c8fcaf9a6d77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c09c-771a-b812-c8fcaf9a6d77",
        "storage_key": "property/5719836663480320/019f150b-c09c-771a-b812-c8fcaf9a6d77.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJNahR_61pXIYRAKAYQUH0qY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_db1563038e2fe117ef62629e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Qargo Coffee",
      "poi_type": "Restaurants",
      "poi_address": "12015 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-609f-75ca-9245-b9cbcf8f9828.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-609f-75ca-9245-b9cbcf8f9828",
        "storage_key": "property/5719836663480320/019f150b-609f-75ca-9245-b9cbcf8f9828.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://qargocoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5102168238867642029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qargo-coffee",
      "poi_latitude": "29.5053395",
      "poi_longitude": "-98.7315272",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 726-230-5150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b989eab91c38",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMwnlrcBpXIYRrXb8FfuKzkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_store"
    },
    {
      "id": "ec_117f353f944015b4e81ef2ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "5447 W Loop 1604 N, San Antonio, TX 78253, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-64cb-708d-8cf4-dd0ae23aa4a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-64cb-708d-8cf4-dd0ae23aa4a8",
        "storage_key": "property/5719836663480320/019f150b-64cb-708d-8cf4-dd0ae23aa4a8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/tx/alamo-ranch?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=17417068257049157535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "29.490135",
      "poi_longitude": "-98.7079449",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-523-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa6gsGmNCXIYRn58l2kzbtfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_177aef8a9dc535e1ab20ad71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Stone Werks Big Rock Grille, Culebra Commons",
      "poi_type": "Restaurants",
      "poi_address": "6626 W Loop 1604 N, San Antonio, TX 78254, USA",
      "poi_short_description": "Rustic eatery with a wide selection of American dishes, a full bar, and patio seating, plus weekend entertainment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-622d-7629-87f4-76af95155317.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-622d-7629-87f4-76af95155317",
        "storage_key": "property/5719836663480320/019f150b-622d-7629-87f4-76af95155317.webp",
        "width": 1280,
        "height": 787
      },
      "poi_business_url": "https://www.stonewerks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11321608478844137174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stone-werks-big-rock-grille-culebra-commons",
      "poi_latitude": "29.5009813",
      "poi_longitude": "-98.6998824",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-688-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ92Qj31CXIYR1i6OU-1uHp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_6b59a0b1fba72ccfd3bb9394",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "MOD Pizza",
      "poi_type": "Restaurants",
      "poi_address": "5619 W Loop 1604 N Suite 101, San Antonio, TX 78253, USA",
      "poi_short_description": "Counter-serve, industrial-chic chain restaurant known for build-your-own pizzas.",
      "poi_long_description": "Counter-serve, industrial-chic chain restaurant known for build-your-own pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-69e5-73e8-b79c-5956de978c3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-69e5-73e8-b79c-5956de978c3f",
        "storage_key": "property/5719836663480320/019f150b-69e5-73e8-b79c-5956de978c3f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.modpizza.com/usa/tx/san-antonio/5619-loop-1605?utm_source=google&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=6620657959420157638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mod-pizza",
      "poi_latitude": "29.49358549999999",
      "poi_longitude": "-98.7070256",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 830-521-4413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0ywUSr5DXIYRxt6ZGlZN4Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_77f3a38e7bf5da798a3b7dad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "5623 W Loop 1604 N, San Antonio, TX 78253, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-6790-7641-b36f-ad93c9352ba8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-6790-7641-b36f-ad93c9352ba8",
        "storage_key": "property/5719836663480320/019f150b-6790-7641-b36f-ad93c9352ba8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/tx/san-antonio/5623-w-loop-1604-n?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=3160",
      "poi_directions_map_url": "https://maps.google.com/?cid=9015651552214939383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "29.4935721",
      "poi_longitude": "-98.7063424",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-688-9082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT6jfGH1CXIYR93Z43FEHHn0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_12c224d8c94496f26bf47557",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "5631 W Loop 1604 N, San Antonio, TX 78253, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-6040-758d-b4ca-23cb844b4eb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-6040-758d-b4ca-23cb844b4eb8",
        "storage_key": "property/5719836663480320/019f150b-6040-758d-b4ca-23cb844b4eb8.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/tx/sanantonio/alamo-ranch-369",
      "poi_directions_map_url": "https://maps.google.com/?cid=746783848300140571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "29.4939771",
      "poi_longitude": "-98.7062679",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-509-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwWbkq9DXIYRG9jtEfQbXQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_1790a71b7c7e858d4d24c798",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "5706 W Loop 1604 N, San Antonio, TX 78251, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-6b77-76d9-af0f-b777192a55d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-6b77-76d9-af0f-b777192a55d9",
        "storage_key": "property/5719836663480320/019f150b-6b77-76d9-af0f-b777192a55d9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/tx/san-antonio/san-antonio-culebra/5364",
      "poi_directions_map_url": "https://maps.google.com/?cid=4752055424527072413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "29.4894076",
      "poi_longitude": "-98.7060099",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-688-3789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13XQG2NCXIYRnXznKzux8kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_23c5c2f8c458925c6680b5fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Las Palapas Alamo Ranch",
      "poi_type": "Restaurants",
      "poi_address": "5603 W Loop 1604 N, San Antonio, TX 78253, USA",
      "poi_short_description": "Local chain offering Mexican & Tex-Mex fare in a casual setup with a drive-thru.",
      "poi_long_description": "Local chain offering Mexican & Tex-Mex fare in a casual setup with a drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-6d0d-7564-853b-0ea6d25baa8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-6d0d-7564-853b-0ea6d25baa8d",
        "storage_key": "property/5719836663480320/019f150b-6d0d-7564-853b-0ea6d25baa8d.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://laspalapas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12650266394960966405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-palapas-alamo-ranch",
      "poi_latitude": "29.4922071",
      "poi_longitude": "-98.707104",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-236-8569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVzZzxCMXIYRBbO1IUPGjq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_843f0a71ae21e21cf8b1c16d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Mama Margies Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10927 FM471, San Antonio, TX 78253, USA",
      "poi_short_description": "Outpost of a casual 24-hour chain with Tex-Mex fare, frozen cocktails, happy hour & a drive-thru.",
      "poi_long_description": "Outpost of a casual 24-hour chain with Tex-Mex fare, frozen cocktails, happy hour & a drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-6f90-727e-a743-b288fa601073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-6f90-727e-a743-b288fa601073",
        "storage_key": "property/5719836663480320/019f150b-6f90-727e-a743-b288fa601073.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mamamargies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9261038845398978382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mama-margies-mexican-restaurant",
      "poi_latitude": "29.4961474",
      "poi_longitude": "-98.7084824",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-277-7090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbctmW3xCXIYRTo8ZR8PRhYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_19982c2715c09e7008322f27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "G Towerz Tacos",
      "poi_type": "Restaurants",
      "poi_address": "11810 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7046-762a-9bcb-b931e893f127.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7046-762a-9bcb-b931e893f127",
        "storage_key": "property/5719836663480320/019f150b-7046-762a-9bcb-b931e893f127.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15709970889363941636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "g-towerz-tacos",
      "poi_latitude": "29.5019728",
      "poi_longitude": "-98.7269099",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-879-5153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwKYaCCTXIYRBOlD9EkHBdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_e6e71b7876af0bb90d5b492e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Deol Bar II At Culebra Alamo Ranch",
      "poi_type": "Restaurants",
      "poi_address": "11804 Culebra Rd #101, San Antonio, TX 78253, USA",
      "poi_short_description": "Convivial tavern offering tap beers & American eats, plus TV sports, karaoke & weekend DJs.",
      "poi_long_description": "Convivial tavern offering tap beers & American eats, plus TV sports, karaoke & weekend DJs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-71c5-73bd-9ffd-1c3046430b1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-71c5-73bd-9ffd-1c3046430b1d",
        "storage_key": "property/5719836663480320/019f150b-71c5-73bd-9ffd-1c3046430b1d.webp",
        "width": 877,
        "height": 494
      },
      "poi_business_url": "http://facebook.com/deolbar2",
      "poi_directions_map_url": "https://maps.google.com/?cid=18026479630065376195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deol-bar-ii-at-culebra-alamo-ranch",
      "poi_latitude": "29.5018908",
      "poi_longitude": "-98.7264022",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-744-3018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c09c-771a-b812-cd5a9423f2fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c09c-771a-b812-cd5a9423f2fb",
        "storage_key": "property/5719836663480320/019f150b-c09c-771a-b812-cd5a9423f2fb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5gvRONpXIYRw5vcFLfrKvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_2e875f81a8a07ec14501bdaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "McAlister's Deli",
      "poi_type": "Restaurants",
      "poi_address": "7010 W Loop 1604 N, San Antonio, TX 78254, USA",
      "poi_short_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_long_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-728c-7644-87c3-3029e633f64d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-728c-7644-87c3-3029e633f64d",
        "storage_key": "property/5719836663480320/019f150b-728c-7644-87c3-3029e633f64d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.mcalistersdeli.com/tx/san-antonio/7010-west-loop-1604-n.?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=10872082695758037328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalisters-deli",
      "poi_latitude": "29.5033353",
      "poi_longitude": "-98.6992072",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-775-5416",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0xkr8JDXIYRUEFU6Ztl4ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_4ab12544a8c17a299bc1a5c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "12125 Alamo Ranch Pkwy, San Antonio, TX 78253, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-315c-774f-8bf2-be35df2a4043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-315c-774f-8bf2-be35df2a4043",
        "storage_key": "property/5719836663480320/019f1508-315c-774f-8bf2-be35df2a4043.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/san-antonio/alamo-ranch-h-e-b-733?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=13742310100097243390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.4865884",
      "poi_longitude": "-98.7313782",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-963-3102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-7301897b24b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-7301897b24b4",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-7301897b24b4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE2t9QBFCXIYR_hiP5Tl-tr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d3d3f088d8552741045a1c60",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "12020 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7343-737f-b0e2-32dfb8619c38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7343-737f-b0e2-32dfb8619c38",
        "storage_key": "property/5719836663480320/019f150b-7343-737f-b0e2-32dfb8619c38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-12020+culebra+rd-san+antonio-tx-78253/id=12716",
      "poi_directions_map_url": "https://maps.google.com/?cid=7570064444363252055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.502658",
      "poi_longitude": "-98.7287852",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-762-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_VE5rfxpXIYRVyEWFYFFDmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_fbdfda0b67bf4ee02870a573",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "13343 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7354-7126-acfc-3dbd326b8083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7354-7126-acfc-3dbd326b8083",
        "storage_key": "property/5719836663480320/019f150b-7354-7126-acfc-3dbd326b8083.webp",
        "width": 1280,
        "height": 1230
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/13343-culebra-road-san-antonio-tx-78253/storeid=10905?WT.mc_id=LS_GOOGLE_FS_10905",
      "poi_directions_map_url": "https://maps.google.com/?cid=18050453914314297051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.515685",
      "poi_longitude": "-98.7589806",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-507-5641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt2jtfm9rXIYR205DHTMYgPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_2ec910bb4fd70af9001a26b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6703 W Loop 1604 N, San Antonio, TX 78254, USA",
      "poi_short_description": "Department store chain carrying a wide selection of items, including clothing, electronics, and home goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7357-73b5-bf8f-a81e3b14bce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7357-73b5-bf8f-a81e3b14bce6",
        "storage_key": "property/5719836663480320/019f150b-7357-73b5-bf8f-a81e3b14bce6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/2864-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17532232128209685442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.50094899999999",
      "poi_longitude": "-98.7047635",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-688-3626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b989eab91c38",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbUb6K35CXIYRwguhGTsAT_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_bde519555582810ab42681ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "5355 W Loop 1604 N, San Antonio, TX 78253, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7926-723e-ad4e-0c45f369a223.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7926-723e-ad4e-0c45f369a223",
        "storage_key": "property/5719836663480320/019f150b-7926-723e-ad4e-0c45f369a223.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/san-antonio-culebra/2426",
      "poi_directions_map_url": "https://maps.google.com/?cid=5511033384945262135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.4931323",
      "poi_longitude": "-98.7102076",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-424-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b989eab91c38",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE_xSoHxCXIYRNx77Nqofe0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_d4b80d594f6e6ae5bcdd016c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "5638 W Loop 1604 N, San Antonio, TX 78251, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-78d1-720a-b891-3428dc06d9bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-78d1-720a-b891-3428dc06d9bb",
        "storage_key": "property/5719836663480320/019f150b-78d1-720a-b891-3428dc06d9bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Culebra/TX/San-Antonio/78251/6818?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13690084967096809113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "29.48856159999999",
      "poi_longitude": "-98.7039671",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-520-4198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b989eab91c38",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTR1ZemJCXIYRmXa4kL7z_L0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_6736670976fab595e68a2b8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "5303 W Loop 1604 N, San Antonio, TX 78253, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7624-73ca-894c-02f8967e17a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7624-73ca-894c-02f8967e17a2",
        "storage_key": "property/5719836663480320/019f150b-7624-73ca-894c-02f8967e17a2.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-San-Antonio/2898?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2898-_-na-_-0-_-0&y_source=1_MTE4Mjg0Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11605026587934535066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "29.48834099999999",
      "poi_longitude": "-98.713311",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-257-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b989eab91c38",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzWS4pmVCXIYRmi3NFjJWDaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_5845059e43fa5fd7f73f169c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5419 W Loop 1604 N, San Antonio, TX 78253, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-77ba-7262-bfca-0101a4ae9a70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-77ba-7262-bfca-0101a4ae9a70",
        "storage_key": "property/5719836663480320/019f150b-77ba-7262-bfca-0101a4ae9a70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/tx/san-antonio/5419-w-loop-1604-n-1459.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=2875533915413707919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "29.488455",
      "poi_longitude": "-98.710098",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-520-5143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b989eab91c38",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn2wamWNCXIYRj3zSX9zy5yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "ec_74918afd38349881aa496669",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Mattress Firm Alamo Ranch",
      "poi_type": "Shopping & Retail",
      "poi_address": "5539 TX-1604 Loop 1604 Suite 112, San Antonio, TX 78253, USA",
      "poi_short_description": "Chain retailer selling a wide array of branded spring, memory foam & adjustable mattresses.",
      "poi_long_description": "Chain retailer selling a wide array of branded spring, memory foam & adjustable mattresses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7ea5-726d-9f08-80b5f66f31a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7ea5-726d-9f08-80b5f66f31a8",
        "storage_key": "property/5719836663480320/019f150b-7ea5-726d-9f08-80b5f66f31a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mattressfirm.com/en-us/stores/tx/san-antonio/005041?utm_source=Google%20My%20Business&utm_medium=organic&utm_campaign=GMB&utm_term=san%20antonio%20tx&utm_kxconfid=uflnw2ovk",
      "poi_directions_map_url": "https://maps.google.com/?cid=15557688760924564374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mattress-firm-alamo-ranch",
      "poi_latitude": "29.4917652",
      "poi_longitude": "-98.7072244",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-680-3902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b989eab91c38",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa6gsGmNCXIYRluv--H8D6Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_59e4ca6b71e7fc576906caae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Culebra Crossing Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8323 Culebra Rd # 103, San Antonio, TX 78251, USA",
      "poi_short_description": "Shopping center featuring a Chinese restaurant, hair salon, liquor store, and bingo.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7b7d-767b-a0f6-3ce33d073f29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7b7d-767b-a0f6-3ce33d073f29",
        "storage_key": "property/5719836663480320/019f150b-7b7d-767b-a0f6-3ce33d073f29.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9933942651759907513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culebra-crossing-shopping-center",
      "poi_latitude": "29.4691123",
      "poi_longitude": "-98.6482184",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-767-1626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b989eab91c38",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b989eab91c38.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEWx4vSVdXIYRuVJAoTV03Ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_720d391850a5d3f897070c40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "William H. Taft High School",
      "poi_type": "Education",
      "poi_address": "11600 FM471, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nisd.net/taft",
      "poi_directions_map_url": "https://maps.google.com/?cid=7867492811001524472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-h-taft-high-school",
      "poi_latitude": "29.4979709",
      "poi_longitude": "-98.7214478",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-397-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxbj_LhFqXIYR-HCvIAfzLm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_f8f880f34d2e73cf3021bb5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "John M. Harlan High School",
      "poi_type": "Education",
      "poi_address": "14350 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7ca8-732b-96ae-a6614f8a78f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7ca8-732b-96ae-a6614f8a78f2",
        "storage_key": "property/5719836663480320/019f150b-7ca8-732b-96ae-a6614f8a78f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nisd.net/harlan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11229204069306120481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-m-harlan-high-school",
      "poi_latitude": "29.5154961",
      "poi_longitude": "-98.7800205",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-398-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq_PEtnJqXIYRIblcLZsl1ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_8c68916fec97ec3700d0222f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "William J. Brennan High School",
      "poi_type": "Education",
      "poi_address": "2400 Cottonwood Way, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7b92-773a-80c8-8b6780881436.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7b92-773a-80c8-8b6780881436",
        "storage_key": "property/5719836663480320/019f150b-7b92-773a-80c8-8b6780881436.webp",
        "width": 876,
        "height": 580
      },
      "poi_business_url": "https://nisd.net/brennan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11412433271138886541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-j-brennan-high-school",
      "poi_latitude": "29.457912",
      "poi_longitude": "-98.7246428",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-398-1250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK8IbgkpCXIYRjSMVLZgbYZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_5a3172aca506c6aaa9138e1a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Bennie L. Cole Elementary School",
      "poi_type": "Education",
      "poi_address": "13185 Tillman Ridge, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nisd.net/cole",
      "poi_directions_map_url": "https://maps.google.com/?cid=2811319786672910562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bennie-l-cole-elementary-school",
      "poi_latitude": "29.45645349999999",
      "poi_longitude": "-98.7549156",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-398-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx5kWMoJBXIYR4nCqcnPQAyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_94cf60911ac41ab87775d24b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Judge Andy Mireles Elementary School",
      "poi_type": "Education",
      "poi_address": "12260 Rockwall Mill, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7e49-72e8-a46f-ad3c1324755f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7e49-72e8-a46f-ad3c1324755f",
        "storage_key": "property/5719836663480320/019f150b-7e49-72e8-a46f-ad3c1324755f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nisd.net/mireles/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13392560328693019052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "judge-andy-mireles-elementary-school",
      "poi_latitude": "29.4917703",
      "poi_longitude": "-98.7354596",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-398-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD8zBsQ9CXIYRrHG8gKnu27k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_88f4612ae240485eee10078e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Legacy Traditional School - Alamo Ranch",
      "poi_type": "Education",
      "poi_address": "13632 Old Farm to Market 471 W, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-80ea-70bd-b72f-5940a618ccb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-80ea-70bd-b72f-5940a618ccb8",
        "storage_key": "property/5719836663480320/019f150b-80ea-70bd-b72f-5940a618ccb8.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://legacytraditional.org/texas/alamo-ranch?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5439771708728286272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-traditional-school---alamo-ranch",
      "poi_latitude": "29.514971",
      "poi_longitude": "-98.7634533",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-239-2737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ93SeTQprXIYRQBz4RYzzfUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_df7c7cc1e6dde93302f037ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Dolph Briscoe Middle School",
      "poi_type": "Education",
      "poi_address": "4265 Lone Star Pkwy, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-7eff-734f-b593-00b1deddfefb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-7eff-734f-b593-00b1deddfefb",
        "storage_key": "property/5719836663480320/019f150b-7eff-734f-b593-00b1deddfefb.webp",
        "width": 605,
        "height": 275
      },
      "poi_business_url": "https://nisd.net/briscoe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17319869261671658244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dolph-briscoe-middle-school",
      "poi_latitude": "29.4732897",
      "poi_longitude": "-98.7289338",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-398-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl6xcBWtCXIYRBHMlMlSJXPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ab9ef2a49105a902f4b1f476",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Dr Joe J Bernal Middle School",
      "poi_type": "Education",
      "poi_address": "14045 Bella Vista Pl, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/bernal/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12494784753255390709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dr-joe-j-bernal-middle-school",
      "poi_latitude": "29.42669009999999",
      "poi_longitude": "-98.7723201",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-398-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5WC4ET9BXIYR9R3BaohkZq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_e889122d61c3fae4d26bfc3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Primrose School at Alamo Ranch",
      "poi_type": "Education",
      "poi_address": "11161 Westwood Loop, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-816a-75fa-a188-ff15458bd2a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-816a-75fa-a188-ff15458bd2a4",
        "storage_key": "property/5719836663480320/019f150b-816a-75fa-a188-ff15458bd2a4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/alamo-ranch/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5391484987820969900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-at-alamo-ranch",
      "poi_latitude": "29.4913328",
      "poi_longitude": "-98.7128223",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-394-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf2C97GVCXIYRrI_r9gdn0ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_c1faae9fcf5935d747488915",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Ivy Kids of Alamo Ranch",
      "poi_type": "Education",
      "poi_address": "5325 Lone Star Pkwy, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-860b-7015-a80a-9585895fea94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-860b-7015-a80a-9585895fea94",
        "storage_key": "property/5719836663480320/019f150b-860b-7015-a80a-9585895fea94.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://ivykids.com/san-antonio-tx/ivy-kids-of-alamo-ranch/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14653480368023765524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ivy-kids-of-alamo-ranch",
      "poi_latitude": "29.4847226",
      "poi_longitude": "-98.7244586",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 830-253-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlU0y37lDXIYRFII328GeW8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_26bfb7915dfaaa4e74928071",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Santikos Casa Blanca",
      "poi_type": "Entertainment",
      "poi_address": "11210 Alamo Ranch Pkwy, San Antonio, TX 78253, USA",
      "poi_short_description": "Movie theater showing the newest releases, as well as gourmet eats served in theater.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-8154-7114-8680-4e7b1dce6e27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-8154-7114-8680-4e7b1dce6e27",
        "storage_key": "property/5719836663480320/019f150b-8154-7114-8680-4e7b1dce6e27.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/san-antonio/casa-blanca/theater-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9204084987399822335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santikos-casa-blanca",
      "poi_latitude": "29.4839101",
      "poi_longitude": "-98.7145134",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c09f-709d-8c89-b37af687e756.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c09f-709d-8c89-b37af687e756",
        "storage_key": "property/5719836663480320/019f150b-c09f-709d-8c89-b37af687e756.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7VHQZWZCXIYR_9t43Id6u38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_dd57a93e18859b8773893540",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "SeaWorld San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "10500 SeaWorld Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_long_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-38b0-7403-a757-03b27153f175.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-38b0-7403-a757-03b27153f175",
        "storage_key": "property/5719836663480320/019f1508-38b0-7403-a757-03b27153f175.webp",
        "width": 1280,
        "height": 952
      },
      "poi_business_url": "https://seaworld.com/san-antonio?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8854466051154083971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seaworld-san-antonio",
      "poi_latitude": "29.4562822",
      "poi_longitude": "-98.6999612",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-520-4732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9c70gFDXIYRg4DL5vVh4Xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_1f22da2af9acf7a16bd30412",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Six Flags Fiesta Texas",
      "poi_type": "Entertainment",
      "poi_address": "San Antonio, TX 78257, USA",
      "poi_short_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_long_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-8747-72eb-937d-6e3a9877a749.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-8747-72eb-937d-6e3a9877a749",
        "storage_key": "property/5719836663480320/019f150b-8747-72eb-937d-6e3a9877a749.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/fiestatexas?utm_source=googlebusinessprofile&utm_medium=organic&utm_campaign=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548967654066146973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-fiesta-texas",
      "poi_latitude": "29.5993818",
      "poi_longitude": "-98.6088838",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 210-697-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN55XmxZlXIYRnc6SjJPAXyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_0be03ce6920089c1d83e0b3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Topgolf San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "5539 N Loop 1604 W, San Antonio, TX 78249, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-8409-71d8-a073-99476de5078f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-8409-71d8-a073-99476de5078f",
        "storage_key": "property/5719836663480320/019f150b-8409-71d8-a073-99476de5078f.webp",
        "width": 800,
        "height": 525
      },
      "poi_business_url": "https://topgolf.com/us/san-antonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18114592869921636103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-san-antonio",
      "poi_latitude": "29.5940894",
      "poi_longitude": "-98.5950414",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-202-2694",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63b5-75ed-82c3-6db01167c74c",
        "storage_key": "property/5719836663480320/019f1508-63b5-75ed-82c3-6db01167c74c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVZ8Xo5hmXIYRB7-Abj32Y_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_178c86e1d532d0641a2439d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Andretti Indoor Karting & Games San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "5527 N Loop 1604 W, San Antonio, TX 78249, USA",
      "poi_short_description": "Indoor amusement hub with arcade games, a go-karting track & bowling, plus a casual restaurant.",
      "poi_long_description": "Indoor amusement hub with arcade games, a go-karting track & bowling, plus a casual restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-879c-70ef-936d-1b798d303ec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-879c-70ef-936d-1b798d303ec2",
        "storage_key": "property/5719836663480320/019f150b-879c-70ef-936d-1b798d303ec2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://andrettikarting.com/sanantonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5476718655430571720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-san-antonio",
      "poi_latitude": "29.5930823",
      "poi_longitude": "-98.5941651",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-469-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ04MIGY5nXIYRyLaxp5k2AUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_9bfb3d83114991877e1b280c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "PINSTACK",
      "poi_type": "Entertainment",
      "poi_address": "19238 I-10, San Antonio, TX 78257, USA",
      "poi_short_description": "Clean entertainment destination featuring state-of-the-art bowling lanes and an elevated game room.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-87aa-733b-8195-aedbdfe22949.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-87aa-733b-8195-aedbdfe22949",
        "storage_key": "property/5719836663480320/019f150b-87aa-733b-8195-aedbdfe22949.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pinstackbowl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13207843838358140137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinstack",
      "poi_latitude": "29.6220783",
      "poi_longitude": "-98.606792",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 45 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-267-9902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfC9pbhlXIYR6TQrKv6vS7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_afe7dca8c16d74c8e4e3251d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "The DoSeum",
      "poi_type": "Entertainment",
      "poi_address": "2800 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_long_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-8b81-766d-85ce-994e84320d0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-8b81-766d-85ce-994e84320d0e",
        "storage_key": "property/5719836663480320/019f150b-8b81-766d-85ce-994e84320d0e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thedoseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15763963794875614826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-doseum",
      "poi_latitude": "29.4533152",
      "poi_longitude": "-98.4716971",
      "poi_miles_from_property": "17.1 mi",
      "poi_walking_minutes": "6 hours 19 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 210-212-4453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c0a9-73fc-97cc-d286e3bedb1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c0a9-73fc-97cc-d286e3bedb1f",
        "storage_key": "property/5719836663480320/019f150b-c0a9-73fc-97cc-d286e3bedb1f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVWnfJL1XIYRagau5YzZxNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_40d269b58320447cc30e89d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Witte Museum",
      "poi_type": "Entertainment",
      "poi_address": "3801 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_long_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-915f-72e4-ad83-e8e5ad6ad764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-915f-72e4-ad83-e8e5ad6ad764",
        "storage_key": "property/5719836663480320/019f150b-915f-72e4-ad83-e8e5ad6ad764.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wittemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14696973662473378755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "witte-museum",
      "poi_latitude": "29.46197799999999",
      "poi_longitude": "-98.4669496",
      "poi_miles_from_property": "17.2 mi",
      "poi_walking_minutes": "6 hours 22 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 210-357-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c0a9-73fc-97cc-d286e3bedb1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c0a9-73fc-97cc-d286e3bedb1f",
        "storage_key": "property/5719836663480320/019f150b-c0a9-73fc-97cc-d286e3bedb1f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SkZWZf1XIYRw1v_mK0j9ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_6eb185f36753ce1f605356f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Aztec Theatre",
      "poi_type": "Entertainment",
      "poi_address": "104 N St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "Ornate concert venue that also stages plays, films and weddings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-9027-77ca-be64-bc5ed55ed46e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-9027-77ca-be64-bc5ed55ed46e",
        "storage_key": "property/5719836663480320/019f150b-9027-77ca-be64-bc5ed55ed46e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.theaztectheatre.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=7852487536378228343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aztec-theatre",
      "poi_latitude": "29.4247856",
      "poi_longitude": "-98.4910964",
      "poi_miles_from_property": "16.7 mi",
      "poi_walking_minutes": "6 hours 9 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 210-812-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYrXrP1ZXIYRd64BYc-j-Ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_ebfcf2c96cdd28cf433e88ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Majestic Theatre",
      "poi_type": "Entertainment",
      "poi_address": "224 E Houston St, San Antonio, TX 78205, USA",
      "poi_short_description": "This ornate Mediterranean-style landmark built in 1929 features touring concerts & Broadway shows.",
      "poi_long_description": "This ornate Mediterranean-style landmark built in 1929 features touring concerts & Broadway shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-8b80-767d-baed-5bed021f2059.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-8b80-767d-baed-5bed021f2059",
        "storage_key": "property/5719836663480320/019f150b-8b80-767d-baed-5bed021f2059.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://us.atgtickets.com/venues/majestic-theatre/whats-on/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5135301984976611197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "majestic-theatre",
      "poi_latitude": "29.4261726",
      "poi_longitude": "-98.4906058",
      "poi_miles_from_property": "16.6 mi",
      "poi_walking_minutes": "6 hours 7 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 888-811-5040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZxkRFNfXIYRfafjhPJBREc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_975e090dbab8f845b855e76e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "The Emergency Center at Alamo Ranch",
      "poi_type": "Health and Wellness",
      "poi_address": "11320 Alamo Ranch Pkwy, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-8bee-75ed-ae60-d43f845855ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-8bee-75ed-ae60-d43f845855ad",
        "storage_key": "property/5719836663480320/019f150b-8bee-75ed-ae60-d43f845855ad.webp",
        "width": 1280,
        "height": 965
      },
      "poi_business_url": "https://www.theemergencycenter.com/san-antonio-er/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1174052364480615231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-emergency-center-at-alamo-ranch",
      "poi_latitude": "29.485643",
      "poi_longitude": "-98.7154285",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-485-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrbi8SG9CXIYRPxOTtGcSSxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_15f2ad053be425ee2ab43041",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Texas MedClinic Urgent Care - Culebra",
      "poi_type": "Health and Wellness",
      "poi_address": "6530 W Loop 1604 N, San Antonio, TX 78254, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-8eb6-70ae-9ff8-67992e9d1f9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-8eb6-70ae-9ff8-67992e9d1f9e",
        "storage_key": "property/5719836663480320/019f150b-8eb6-70ae-9ff8-67992e9d1f9e.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://www.texasmedclinic.com/location/loop-1604-n-culebra/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9666918978927911441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-medclinic-urgent-care---culebra",
      "poi_latitude": "29.4973519",
      "poi_longitude": "-98.7017741",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-476-5577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30gJPGRoXIYREeJ6A5jLJ4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_ff507616d04c266cdcdd2a34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "NextCare Urgent Care, San Antonio (Culebra Rd)",
      "poi_type": "Health and Wellness",
      "poi_address": "11282 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-9103-775f-b9c0-0e413c082a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-9103-775f-b9c0-0e413c082a6d",
        "storage_key": "property/5719836663480320/019f150b-9103-775f-b9c0-0e413c082a6d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nextcare.com/locations/tx/san-antonio-culebra-rd/?utm_source=google&utm_medium=organic&utm_campaign=google_maps&utm_content=culebra",
      "poi_directions_map_url": "https://maps.google.com/?cid=13278456892973274484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nextcare-urgent-care-san-antonio-culebra-rd",
      "poi_latitude": "29.4974358",
      "poi_longitude": "-98.7152093",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-802-2660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubokXHdCXIYRdFUCHzGORrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_8d06eeab45a2b70ce340d608",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Mercy Wellness Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "11911 Culebra Rd Ste 107, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-953d-7607-9079-25f6245e6057.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-953d-7607-9079-25f6245e6057",
        "storage_key": "property/5719836663480320/019f150b-953d-7607-9079-25f6245e6057.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mercywellnessclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17261226906996485174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-wellness-clinic",
      "poi_latitude": "29.5037683",
      "poi_longitude": "-98.7283899",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 830-438-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM9NrFDtpXIYRNqzwAmsyjO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_35df395ffbc3ee36461093d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12020 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-916b-70ea-9fbe-8ec13be46c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-916b-70ea-9fbe-8ec13be46c65",
        "storage_key": "property/5719836663480320/019f150b-916b-70ea-9fbe-8ec13be46c65.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-12020+culebra+rd-san+antonio-tx-78253/id=12716",
      "poi_directions_map_url": "https://maps.google.com/?cid=3707834479574217219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "29.5026528",
      "poi_longitude": "-98.7287796",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-762-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c09d-7478-964c-0b7189dbeaad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c09d-7478-964c-0b7189dbeaad",
        "storage_key": "property/5719836663480320/019f150b-c09d-7478-964c-0b7189dbeaad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyR9QLeBpXIYRA3L3cNDfdDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_e47eff4875c5354da9a5a7bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "13343 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-961b-7259-9e14-dc14f4c0c2b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-961b-7259-9e14-dc14f4c0c2b1",
        "storage_key": "property/5719836663480320/019f150b-961b-7259-9e14-dc14f4c0c2b1.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/13343-culebra-road-san-antonio-tx-78253/storeid=10905?WT.mc_id=LS_GOOGLE_RX_10905",
      "poi_directions_map_url": "https://maps.google.com/?cid=15976372729929791875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.51585369999999",
      "poi_longitude": "-98.7591328",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-507-5641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c09d-7478-964c-0b7189dbeaad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c09d-7478-964c-0b7189dbeaad",
        "storage_key": "property/5719836663480320/019f150b-c09d-7478-964c-0b7189dbeaad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc58i-MVrXIYRg_mz9ll6t90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_3d9491f45f25928aede23a93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12125 Alamo Ranch Pkwy, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-966b-75b9-a373-fb0491f44f8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-966b-75b9-a373-fb0491f44f8b",
        "storage_key": "property/5719836663480320/019f150b-966b-75b9-a373-fb0491f44f8b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=7970896073878517615&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "29.4866404",
      "poi_longitude": "-98.7314594",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-688-9584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c09d-7478-964c-0b7189dbeaad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c09d-7478-964c-0b7189dbeaad",
        "storage_key": "property/5719836663480320/019f150b-c09d-7478-964c-0b7189dbeaad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ56K1Z2xCXIYRb7cVYb9Pnm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_126c9f44de389b577147bf71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11019 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-3cfb-736c-b57b-256680cb4534.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-3cfb-736c-b57b-256680cb4534",
        "storage_key": "property/5719836663480320/019f1508-3cfb-736c-b57b-256680cb4534.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/san-antonio-westwood-center-tx?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2081815221522363099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.4977749",
      "poi_longitude": "-98.7099774",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 830-689-5745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbrXMlVDXIYR23LX_ukX5Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_3f776ecc7fa9299800cb7ce4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Orangetheory Fitness- Kallison Ranch",
      "poi_type": "Health and Wellness",
      "poi_address": "15489 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-9801-76c9-a9eb-7350b3f37e6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-9801-76c9-a9eb-7350b3f37e6d",
        "storage_key": "property/5719836663480320/019f150b-9801-76c9-a9eb-7350b3f37e6d.webp",
        "width": 1170,
        "height": 767
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/san-antonio-texas-1652",
      "poi_directions_map_url": "https://maps.google.com/?cid=9326768537668480016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness--kallison-ranch",
      "poi_latitude": "29.5242958",
      "poi_longitude": "-98.8006553",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-764-4715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUZlL7OlrXIYREOwE1pFWb4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_c863f8e3f193729450371045",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "F45 Training Alamo Ranch TX",
      "poi_type": "Health and Wellness",
      "poi_address": "11911 Culebra Rd Ste 101, San Antonio, TX 78253, USA",
      "poi_short_description": "Fun gym with 45-minute classes, plus personal training, community vibes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-9861-73f8-943e-73a522d6ef7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-9861-73f8-943e-73a522d6ef7e",
        "storage_key": "property/5719836663480320/019f150b-9861-73f8-943e-73a522d6ef7e.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://f45training.com/studio/alamoranchtx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=59842012009188630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f45-training-alamo-ranch-tx",
      "poi_latitude": "29.5037509",
      "poi_longitude": "-98.72817",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-960-3799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWOgAjdpXIYRFs1zLP6Z1AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_791d83c2437ad7700f3bb6b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Culebra Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10919 Westwood Loop, San Antonio, TX 78254, USA",
      "poi_short_description": "Roughly 145 acres boasting grassy & wooded areas, a walking trail & multipurpose sport fields.",
      "poi_long_description": "Roughly 145 acres boasting grassy & wooded areas, a walking trail & multipurpose sport fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-99ee-77fc-94fb-3ee046a6b1f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-99ee-77fc-94fb-3ee046a6b1f6",
        "storage_key": "property/5719836663480320/019f150b-99ee-77fc-94fb-3ee046a6b1f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Culebra-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11012182010559695994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culebra-creek-park",
      "poi_latitude": "29.4983731",
      "poi_longitude": "-98.7088968",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJWly9nhCXIYReoxbjTEh05g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d270b38964374383688ccbca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Terra Oak Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10140 Terra Oak, San Antonio, TX 78250, USA",
      "poi_short_description": "Paved trail winding through wildflowers and shaded trees for walking and jogging.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-9cca-726c-9357-bf2c62055a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-9cca-726c-9357-bf2c62055a8c",
        "storage_key": "property/5719836663480320/019f150b-9cca-726c-9357-bf2c62055a8c.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16182258424388281884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terra-oak-trailhead",
      "poi_latitude": "29.506403",
      "poi_longitude": "-98.6915441",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbb4uCdoXIYRHGY8uUzukuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_271e15de8db32deb2bc86c5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Caracol Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Far West Side, San Antonio, TX 78245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-a098-7448-adf1-ab5f846e8329.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-a098-7448-adf1-ab5f846e8329",
        "storage_key": "property/5719836663480320/019f150b-a098-7448-adf1-ab5f846e8329.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Caracol-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15688866138455559438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caracol-creek-park",
      "poi_latitude": "29.4328945",
      "poi_longitude": "-98.7056741",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr7RFHgpDXIYRDk1MN6EMutk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a12032c464a0ac99dbb09118",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "West Creek Sports Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12354 Military Dr W, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-9a87-74c8-94cd-4bb83d550182.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-9a87-74c8-94cd-4bb83d550182",
        "storage_key": "property/5719836663480320/019f150b-9a87-74c8-94cd-4bb83d550182.webp",
        "width": 472,
        "height": 631
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11515504203006477389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-creek-sports-park",
      "poi_latitude": "29.43767369999999",
      "poi_longitude": "-98.7316337",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlaCgHwBDXIYRTQS4lQ9Kz58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f92128fa07bf74995aa13dd3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Stillwater Ranch Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7907 High Lonesome, San Antonio, TX 78254, USA",
      "poi_short_description": "Neighborhood spot with a pool, tennis courts and playground, as well as a basketball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-9f13-7480-a443-28d517dfbd95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-9f13-7480-a443-28d517dfbd95",
        "storage_key": "property/5719836663480320/019f150b-9f13-7480-a443-28d517dfbd95.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9585046773234451369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwater-ranch-community-park",
      "poi_latitude": "29.5139496",
      "poi_longitude": "-98.7420179",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3y-t_BpXIYRqcMkqkHtBIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_99e53954c458000de4f2dc48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Silver Oaks Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11716 Oakwood Ridge, San Antonio, TX 78254, USA",
      "poi_short_description": "Tree-shaded park featuring playground equipment, slides and swings, plus an open, grassy play area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-9fe9-73fa-8ff9-42a14be28094.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-9fe9-73fa-8ff9-42a14be28094",
        "storage_key": "property/5719836663480320/019f150b-9fe9-73fa-8ff9-42a14be28094.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://silveroakssa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9904015387284617919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-oaks-community-park",
      "poi_latitude": "29.51621889999999",
      "poi_longitude": "-98.7254975",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM17ChcJpXIYRvzoaYYUhcok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4c465cf7df6bea5a82bb025d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Wildhorse Vistas Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9018 Gallop Chase, San Antonio, TX 78254, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18401004927438471747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wildhorse-vistas-park",
      "poi_latitude": "29.5255259",
      "poi_longitude": "-98.7054294",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGfGEk8ppXIYRQ8IuIn2AXf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9ea1d2f1530f26f7d919d137",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Government Canyon State Natural Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12861 Galm Rd, San Antonio, TX 78254, USA",
      "poi_short_description": "Tranquil park featuring multi-use trails from rugged to beginner-friendly, plus guided canyon hikes.",
      "poi_long_description": "Tranquil park featuring multi-use trails from rugged to beginner-friendly, plus guided canyon hikes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-4cb6-75fd-8df5-57b7a64fd825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-4cb6-75fd-8df5-57b7a64fd825",
        "storage_key": "property/5719836663480320/019f1508-4cb6-75fd-8df5-57b7a64fd825.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tpwd.texas.gov/state-parks/government-canyon",
      "poi_directions_map_url": "https://maps.google.com/?cid=11615951085383130630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "government-canyon-state-natural-area",
      "poi_latitude": "29.549356",
      "poi_longitude": "-98.764798",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-688-9055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWz1--NrXIYRBh6T3PclNKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_206201fa32fde40995093a2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "New Territories Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9023 Bowen Dr, San Antonio, TX 78250, USA",
      "poi_short_description": "Dog-friendly park with a swimming pool (seasonal and public), courts for tennis and basketball, and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-a2f8-74c2-9ae1-12cb3384eb7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-a2f8-74c2-9ae1-12cb3384eb7b",
        "storage_key": "property/5719836663480320/019f150b-a2f8-74c2-9ae1-12cb3384eb7b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2550/New-Territories?Park=168&Facility=",
      "poi_directions_map_url": "https://maps.google.com/?cid=17723203929059768423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-territories-park",
      "poi_latitude": "29.5180836",
      "poi_longitude": "-98.6698145",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwaE4lw9oXIYRZzhqaRJ49fU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1e1b05d11edfeb7dd0b95b2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Stonefield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10111 Stonefield Pl, San Antonio, TX 78254, USA",
      "poi_short_description": "Park featuring a playground, swimming pool, and facilities for basketball, and picnicking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-aa77-770f-82cf-4bbc19eabe42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-aa77-770f-82cf-4bbc19eabe42",
        "storage_key": "property/5719836663480320/019f150b-aa77-770f-82cf-4bbc19eabe42.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18169765953255071507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stonefield-park",
      "poi_latitude": "29.5417787",
      "poi_longitude": "-98.666153",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-640c-74b8-a1a5-e31159665463",
        "storage_key": "property/5719836663480320/019f1508-640c-74b8-a1a5-e31159665463.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVryGXpoXIYRE1_B7935J_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_60698bffce93102e74fb4a6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Alamo Ranch Pkwy & Alamo Pkwy",
      "poi_type": "Transportation & Transit",
      "poi_address": "Far West Side, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3877923129029295990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-ranch-pkwy--alamo-pkwy",
      "poi_latitude": "29.48458",
      "poi_longitude": "-98.73475",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM7ST0xBCXIYRdv8PLIom0TU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_6c09ea9798db9299a5050de7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Westwood Loop & Culebra Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Far West Side, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10141387120654415506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-loop--culebra-rd",
      "poi_latitude": "29.4951",
      "poi_longitude": "-98.71021",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xzZhHtCXIYRkvZT2NpxvYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_bafada414e34a7a96570a4c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Gallery Ridge & Dover Ridge",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78250, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3821304816040386307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallery-ridge--dover-ridge",
      "poi_latitude": "29.50958",
      "poi_longitude": "-98.680433",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJycJBPh9oXIYRA5-T6nsACDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_51781079ab13e45fd90ddc5a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Potranco & Loop 1604",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8208124739260405155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "potranco--loop-1604",
      "poi_latitude": "29.43576",
      "poi_longitude": "-98.70954",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmZ6FiqFDXIYRo1W2O_Yd6XE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_95ff8834bf0b9bb1a77053dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Ingram Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3215 Northwestern Dr, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-a73c-7238-994d-ae6aab4b3504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-a73c-7238-994d-ae6aab4b3504",
        "storage_key": "property/5719836663480320/019f150b-a73c-7238-994d-ae6aab4b3504.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.viainfo.net/transit-centers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15286896482762599812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingram-transit-center",
      "poi_latitude": "29.4648153",
      "poi_longitude": "-98.6257608",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-521-6773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryXVZVvZ-4YRhK07jVv3JdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_1db40dcec9ab6ab401ea94d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "VIA Crossroads Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "151 N Crossroads Blvd, Balcones Heights, TX 78201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-a943-7675-96b2-ef1946cccd4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-a943-7675-96b2-ef1946cccd4a",
        "storage_key": "property/5719836663480320/019f150b-a943-7675-96b2-ef1946cccd4a.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14912817806174523366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-crossroads-park--ride",
      "poi_latitude": "29.493575",
      "poi_longitude": "-98.5483679",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 210-362-2892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c0b9-7648-b4ad-a053a65ea05b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c0b9-7648-b4ad-a053a65ea05b",
        "storage_key": "property/5719836663480320/019f150b-c0b9-7648-b4ad-a053a65ea05b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXQTzYRfXIYR5g8ngcj49M4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_b96644589449af6bb5d0d613",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "VIA Stone Oak Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "22139 US-281, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-a30b-7378-b0f9-48f521df237f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-a30b-7378-b0f9-48f521df237f",
        "storage_key": "property/5719836663480320/019f150b-a30b-7378-b0f9-48f521df237f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.viainfo.net/park-ride-commuting/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18423806789292463184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-stone-oak-park--ride",
      "poi_latitude": "29.6480735",
      "poi_longitude": "-98.452267",
      "poi_miles_from_property": "22.2 mi",
      "poi_walking_minutes": "8 hours 19 mins",
      "poi_biking_minutes": "2 hours 21 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 210-362-2887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-c0b9-7648-b4ad-a053a65ea05b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-c0b9-7648-b4ad-a053a65ea05b",
        "storage_key": "property/5719836663480320/019f150b-c0b9-7648-b4ad-a053a65ea05b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47WvqEaJXIYRUBQ1TqmCrv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_61d1d63eced3783a3fce3dd4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Texas MedClinic Urgent Care - Culebra",
      "poi_type": "Transportation & Transit",
      "poi_address": "6530 W Loop 1604 N, San Antonio, TX 78254, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-8eb6-70ae-9ff8-67992e9d1f9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-8eb6-70ae-9ff8-67992e9d1f9e",
        "storage_key": "property/5719836663480320/019f150b-8eb6-70ae-9ff8-67992e9d1f9e.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://www.texasmedclinic.com/location/loop-1604-n-culebra/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9666918978927911441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-medclinic-urgent-care---culebra",
      "poi_latitude": "29.4973519",
      "poi_longitude": "-98.7017741",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-476-5577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30gJPGRoXIYREeJ6A5jLJ4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_d978d55d50198dfc43413c23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "NW Loop 410 S Access Rd & SH 151",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8308101597493088994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nw-loop-410-s-access-rd--sh-151",
      "poi_latitude": "29.438174",
      "poi_longitude": "-98.643039",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRQqV79cXIYR4lJufGJOTHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_0295c496f6342e2017601266",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-a74d-71af-a5b3-0e953954ed17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-a74d-71af-a5b3-0e953954ed17",
        "storage_key": "property/5719836663480320/019f150b-a74d-71af-a5b3-0e953954ed17.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "20.1 mi",
      "poi_walking_minutes": "7 hours 32 mins",
      "poi_biking_minutes": "2 hours 11 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63c4-74ac-8f65-1a94a4823258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63c4-74ac-8f65-1a94a4823258",
        "storage_key": "property/5719836663480320/019f1508-63c4-74ac-8f65-1a94a4823258.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_83f7da9b3088ed3018761a3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Toyota Motor Manufacturing, Texas, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lone Star Pass, San Antonio, TX 78264, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-a86b-74ac-9cb2-546e2e8c1234.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-a86b-74ac-9cb2-546e2e8c1234",
        "storage_key": "property/5719836663480320/019f150b-a86b-74ac-9cb2-546e2e8c1234.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.toyota.com/usa/operations/map/tmmtx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3739277978480632304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toyota-motor-manufacturing-texas-inc",
      "poi_latitude": "29.2574587",
      "poi_longitude": "-98.5429684",
      "poi_miles_from_property": "26.9 mi",
      "poi_walking_minutes": "9 hours 51 mins",
      "poi_biking_minutes": "2 hours 15 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt-W_7exWXIYR8GHHh4KV5DM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_91c0a5ca70c59e250a1fb9cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Lackland AFB Luke Gate Visitor Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2602 Luke Blvd, Lackland Air Force Base, TX 78236, USA",
      "poi_short_description": "Visitor center on a military base with free admission.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-ac4e-724d-99bc-2da2384f4871.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-ac4e-724d-99bc-2da2384f4871",
        "storage_key": "property/5719836663480320/019f150b-ac4e-724d-99bc-2da2384f4871.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jbsa.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10235394574387412108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lackland-afb-luke-gate-visitor-center",
      "poi_latitude": "29.3936557",
      "poi_longitude": "-98.621966",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-671-6174",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSCIWQlbXIYRjHxSziJtC44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "ec_bfc1be642019a3a7d9816c6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Valero",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Valero Way, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-b176-7378-aa9b-e692f13e6c2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-b176-7378-aa9b-e692f13e6c2c",
        "storage_key": "property/5719836663480320/019f150b-b176-7378-aa9b-e692f13e6c2c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.valero.com/ourbusiness/ourlocations/offices/pages/valerocorporateheadquarters.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16201185604516536043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero",
      "poi_latitude": "29.5869869",
      "poi_longitude": "-98.6070957",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-345-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1eqHI5mXIYR615hQXgs1uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_963bc2a5d774f7231aaaaad9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "USAA Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Fredericksburg Rd, San Antonio, TX 78288, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-b3b9-7100-ae6f-2e15ba0bc27a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-b3b9-7100-ae6f-2e15ba0bc27a",
        "storage_key": "property/5719836663480320/019f150b-b3b9-7100-ae6f-2e15ba0bc27a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.usaa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341051404387659836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usaa-corporate-office",
      "poi_latitude": "29.5371902",
      "poi_longitude": "-98.5752478",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-531-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyb6ITJnXIYRPLBolFun4GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_8b19f1cfcc567bcf91e12993",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "The University of Texas at San Antonio",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Physical Education Building, 1 UTSA Circle, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-acda-706f-8524-0ba4dc9d793e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-acda-706f-8524-0ba4dc9d793e",
        "storage_key": "property/5719836663480320/019f150b-acda-706f-8524-0ba4dc9d793e.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://www.utsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2658632929587635980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-san-antonio",
      "poi_latitude": "29.5830733",
      "poi_longitude": "-98.6198779",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-458-4011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3X9l1n1mXIYRDCc6PJBc5SQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_36a292d88b62f50c2c0756e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "University Health University Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4502 Medical Dr, San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-b159-735d-98d8-e3856aec6c08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-b159-735d-98d8-e3856aec6c08",
        "storage_key": "property/5719836663480320/019f150b-b159-735d-98d8-e3856aec6c08.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.universityhealth.com/locations/university-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=3269778978862236901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-university-hospital",
      "poi_latitude": "29.5078888",
      "poi_longitude": "-98.5775051",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 210-358-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b7a696b4594d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b7a696b4594d",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b7a696b4594d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSW2JPldXIYR5YQfQaiWYC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_194d9a81797331563e054783",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Brooke Army Medical Center (BAMC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3551 Roger Brooke Dr, Fort Sam Houston, TX 78234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-b56a-754b-b1f2-29582f13d090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-b56a-754b-b1f2-29582f13d090",
        "storage_key": "property/5719836663480320/019f150b-b56a-754b-b1f2-29582f13d090.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://bamc.tricare.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5581840337299951468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brooke-army-medical-center-bamc",
      "poi_latitude": "29.460187",
      "poi_longitude": "-98.4162656",
      "poi_miles_from_property": "21.6 mi",
      "poi_walking_minutes": "7 hours 57 mins",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 210-916-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a6-70b9-8b0a-b7a696b4594d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a6-70b9-8b0a-b7a696b4594d",
        "storage_key": "property/5719836663480320/019f1508-63a6-70b9-8b0a-b7a696b4594d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8nfo2n0XIYRbM-1gTaudk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_c67c8260d5a0b2eab3d554bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "H-E-B Corporate Office Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "646 S Flores St, San Antonio, TX 78204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-b1d1-769a-bc2b-9700d2cdadbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-b1d1-769a-bc2b-9700d2cdadbf",
        "storage_key": "property/5719836663480320/019f150b-b1d1-769a-bc2b-9700d2cdadbf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/static-page/heb-corporate-office-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485037645668446608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-corporate-office-headquarters",
      "poi_latitude": "29.4172323",
      "poi_longitude": "-98.4954226",
      "poi_miles_from_property": "16.9 mi",
      "poi_walking_minutes": "6 hours 14 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 210-938-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfrImLFYXIYRkHGqxi9WgpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_e84d82fe1821948074209978",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Sunoco LP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19003 Interstate 10 West Frontage Road, San Antonio, TX 78257, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f150b-b5b0-718a-ada9-c12815315296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150b-b5b0-718a-ada9-c12815315296",
        "storage_key": "property/5719836663480320/019f150b-b5b0-718a-ada9-c12815315296.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sunocolp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18412512083693481572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunoco-lp",
      "poi_latitude": "29.61828",
      "poi_longitude": "-98.6046516",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-918-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63d5-74ce-84a6-116be616f13a",
        "storage_key": "property/5719836663480320/019f1508-63d5-74ce-84a6-116be616f13a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuWfvm39hXIYRZC4juy9ihv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_35ce1fd2cd6ca0f4c8595672",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "poi_name": "Northside Independent School District Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5900 Evers Rd, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=592429851399403552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-independent-school-district-administration-building",
      "poi_latitude": "29.4908341",
      "poi_longitude": "-98.6012233",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 210-397-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1508-63a7-727e-9d8f-6e6d97f32028",
        "storage_key": "property/5719836663480320/019f1508-63a7-727e-9d8f-6e6d97f32028.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx7e68JZdXIYRILj_ns-7OAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_d0e8fb20-b1f4-4e1f-8ac8-71254e9b721d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_d13a7d25-8289-4626-93ec-2a2f13dc639a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_9c567d01-b201-439b-a361-954fd3e05123",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_12ed0e7f-98ab-4362-becb-c4d6b545e74b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_53717951-1075-4781-baeb-9c0fddcb47ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_c71fa29c-178f-4075-8aaa-83e855761a98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_22f1a7df-4194-4021-9079-f7da78971932",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "rating": "5.0",
      "name": "Betty Jean Medina",
      "text": "I would like to take a moment to recognize Jeanette Martinez for the outstanding job she does as our apartment. As a tenant, I have had nothing but positive experiences with her. Jeanette is professional, knowledgeable, compassionate, and truly dedicated to the residents she serves.\nShe always goes above and beyond to ensure that any questions, concerns, or maintenance issues are addressed promptly and efficiently. What sets her apart is her genuine kindness and willingness to help. She treats everyone with respect and makes residents feel valued and heard.\nJeanette has created a welcoming and positive community where people feel comfortable and proud to call home. Her hard work, attention to detail, and commitment to excellence are evident in everything she does. It is clear that she cares deeply about both the property and the people who live here.\nThank you, Jeanette, for your dedication, professionalism, and the positive impact you make every day. Our community is fortunate to have you, and I highly recommend this property because of the exceptional management and care you provide.",
      "date": "2026-05-30",
      "title": ""
    },
    {
      "id": "custom_da2d0983-d469-4697-8d15-563b6aa2f7d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "rating": "5.0",
      "name": "Sam M lane",
      "text": "I love these apartments and the front staff Jessica and Janette super helpful and very welcoming people. I’m actually renewing my lease and plan to stay here with them. The pool and the apartment complex Is always clean thanks to the maintenance team who are also very sweet!\n\nNot to mention they have cute gatherings for certain events very fun for adults and kids",
      "date": "2026-04-17",
      "title": ""
    },
    {
      "id": "custom_dff597c9-3c6a-455f-8357-055f70fd21e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "rating": "5.0",
      "name": "Sylvia Sierra",
      "text": "Super excited to see that the new staff have given outstanding service. The manager Jessica and Jeannette the leasing has helped me a lot with one of my clients that I’m relocating. Glad to see they’re on board beautiful property and they go over and above to help people get their moved done. Looking forward to bringing more business to you.",
      "date": "2026-04-14",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_b2612b40fabf02db6c18717e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f14c4-409d-73b6-8527-92e66eff6a20.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-409d-73b6-8527-92e66eff6a20",
        "storage_key": "property/5719836663480320/019f14c4-409d-73b6-8527-92e66eff6a20.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Ember at Alamo Ranch Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/7D7NRvJOdwI"
    }
  ],
  "faqs": [
    {
      "id": "custom_eb9ac103-92a2-4959-9813-2afdc3cc2e51",
      "question": "Is Ember at Alamo Ranch pet-friendly?",
      "answer": "Yes. Ember at Alamo Ranch welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (210) 688-0380 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_fe071b8f-cd05-43c9-925c-cb64fb44ac93",
      "question": "How can I schedule a tour at Ember at Alamo Ranch?",
      "answer": "You can schedule a tour of Ember at Alamo Ranch online through our Schedule a Tour page, or call the leasing office at (210) 688-0380. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_5f020412-6708-4792-8f4e-482abeaf8b3d",
      "question": "What are the leasing office hours at Ember at Alamo Ranch?",
      "answer": "The Ember at Alamo Ranch leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (210) 688-0380 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_07ae2ea7-c906-4de8-b15a-76ca55b1a944",
      "question": "What floor plans are available at Ember at Alamo Ranch?",
      "answer": "Ember at Alamo Ranch offers 1- and 2-bedroom apartment homes ranging from approximately 499 to 937 square feet, across 4 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_d5b615ed-bf2a-458f-a74c-4e040c3d1c79",
      "question": "What amenities does Ember at Alamo Ranch have?",
      "answer": "Ember at Alamo Ranch offers a range of community and in-home amenities. Community amenities include: Wooded Jogging Trail, Fitness Center, Clubhouse, Controlled Access, Storage Space, Pool, Convenient Online Resident Services, and American Landmark 360 Program. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_b4bca61d-8c50-4d53-8799-1d1197da4c51",
      "question": "Where is Ember at Alamo Ranch located?",
      "answer": "Ember at Alamo Ranch is located at 11022 Culebra Rd, San Antonio TX 78253. Nearby you'll find dining at Colombia Tierra Querida, shopping at H-E-B, and green space at Culebra Creek Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_853d551c-dc8a-4cce-a536-baffc16258fd",
      "question": "How do I apply to live at Ember at Alamo Ranch?",
      "answer": "You can apply to live at Ember at Alamo Ranch online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (210) 688-0380 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_2cadb89a-4703-4b0e-b1a5-7d2209af7dc1",
      "question": "What do I need to apply at Ember at Alamo Ranch?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Ember at Alamo Ranch leasing team at (210) 688-0380 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_b176a22e-9ad8-406e-98db-045588d5cece",
      "question": "What is the Landmark 360 program at Ember at Alamo Ranch?",
      "answer": "Ember at Alamo Ranch participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (210) 688-0380 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_ad36a4b6-c67a-47a3-ac50-d9806ad123a3",
      "question": "Does Ember at Alamo Ranch have a pool?",
      "answer": "Yes. Ember at Alamo Ranch has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_111553f6-b6d2-4020-b8ac-88c3a6218446",
      "question": "Does Ember at Alamo Ranch have a fitness center?",
      "answer": "Yes. Ember at Alamo Ranch has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_63d9b2f6-e0f7-4437-887f-cbaac74ae61c",
      "question": "Does Ember at Alamo Ranch offer virtual tours?",
      "answer": "Yes. Ember at Alamo Ranch offers virtual tours of Ember at Alamo Ranch Community Tour. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_3de13dd8-4031-44a6-b08e-73ddbc5a206a",
      "question": "What do residents say about living at Ember at Alamo Ranch?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Ember at Alamo Ranch. One resident wrote: *\"I love these apartments and the front staff Jessica and Janette super helpful and very welcoming people. I’m actually renewing my lease and plan to stay here with them.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_c6d73940-2856-4fa8-99c5-146111a596ca",
      "question": "When was Ember at Alamo Ranch built?",
      "answer": "Ember at Alamo Ranch was built in 2015 and renovated in 2022. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_0b698dca-0d2c-42f8-b075-0827d3cd8045",
      "question": "What is the pet fee at Ember at Alamo Ranch?",
      "answer": "Pets at Ember at Alamo Ranch: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (210) 688-0380 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_a7491a2b-f3f7-4c06-a9f5-e1c4f21608a0",
      "question": "What restaurants and shops are near Ember at Alamo Ranch?",
      "answer": "Nearby restaurants and shops include Colombia Tierra Querida, Starbucks Coffee Company, Black Rock Coffee Bar, and Qargo Coffee. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-7576-704f-bb8b-117e084639eb",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "ember-at-alamo-ranch",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320"
    },
    {
      "lead_collector_id": "0198aa45-75dc-77bf-92cf-e2a81b52f46c",
      "lead_source": "FACEBOOK_ADS",
      "name": "ember-at-alamo-ranch",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320"
    },
    {
      "lead_collector_id": "0198aa45-7641-775c-ac29-571cb4b8b509",
      "lead_source": "LANDING_PAGE",
      "name": "ember-at-alamo-ranch",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-san-antonio-tx",
      "search_query": "One Bedroom Apartments For Rent In San Antonio TX",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In San Antonio TX",
      "h2_subtitle": "Ember @ Alamo Ranch offers modern living in a vibrant community. Enjoy proximity to top schools, military bases, and exciting local attractions.",
      "page_copy": "Ember @ Alamo Ranch is your destination for one bedroom apartments for rent in San Antonio TX, where modern amenities meet a thriving community. Located just sixteen miles west of downtown, this pet-friendly community is perfect for those seeking a balance between city life and suburban tranquility. With top schools like Northwest Vista College nearby, it's an ideal spot for students and families alike. \n\nResidents enjoy easy access to the Government Canyon State Natural Area for outdoor adventures, while the National Shooting Complex and SeaWorld San Antonio provide endless entertainment options. Each apartment features high-speed internet, stainless steel appliances, and spacious walk-in closets, ensuring comfort and convenience. Whether you're a student, a military family, or simply looking for a new home, Ember @ Alamo Ranch has the perfect one bedroom apartment for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | One Bedroom Apartments For Rent In San Antonio TX",
      "seo_description": "Explore Ember @ Alamo Ranch for one bedroom apartments for rent in San Antonio TX. Enjoy modern amenities and a vibrant community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-san-antonio-tx",
      "search_query": "Two Bedrooms Apartments For Rent In San Antonio TX",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In San Antonio TX",
      "h2_subtitle": "Ember @ Alamo Ranch offers spacious two-bedroom apartments in a thriving community. Enjoy modern amenities and a prime location near top schools and attractions.",
      "page_copy": "Ember @ Alamo Ranch is the perfect choice for those seeking two bedrooms apartments for rent in San Antonio TX. Situated in the rapidly growing Far West Side, this pet-friendly community offers a blend of suburban peace and urban convenience. With proximity to Northwest Vista College and the Latin American Bible Institute, it's an ideal location for students and families.\n\nResidents can enjoy the natural beauty of the Government Canyon State Natural Area and the excitement of nearby attractions like the National Shooting Complex and SeaWorld San Antonio. Each apartment features high-speed internet, granite countertops, and spacious walk-in closets, providing a comfortable and modern living experience. Whether you're a student, a military family, or simply looking for a spacious new home, Ember @ Alamo Ranch has the perfect two-bedroom apartment for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Two Bedrooms Apartments For Rent In San Antonio TX",
      "seo_description": "Discover two bedrooms apartments for rent in San Antonio TX at Ember @ Alamo Ranch. Enjoy modern amenities and a vibrant community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pool-ember-alamo-ranch",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pool at Ember @ Alamo Ranch",
      "h2_subtitle": "Ember @ Alamo Ranch offers luxurious living with a pool and more. Enjoy a vibrant community with top amenities and a prime location in San Antonio.",
      "page_copy": "Discover the perfect apartments for rent near me with pool at Ember @ Alamo Ranch, where luxury meets convenience. Located in the thriving Far West Side of San Antonio, this pet-friendly community offers a serene escape from the bustling city life. With top schools and military bases nearby, it's an ideal location for families and professionals alike.\n\nResidents can enjoy a refreshing swim in the community pool, stay active at the fitness center, or relax on the sundeck. The community also features a dog park, walking trails, and a clubhouse for social gatherings. With controlled access and modern amenities like EV charging and online services, Ember @ Alamo Ranch provides a comfortable and secure living environment. Experience the best of San Antonio living with a pool and more at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore apartments for rent near me with pool at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in San Antonio's Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Fitness Center at Ember @ Alamo Ranch",
      "h2_subtitle": "Ember @ Alamo Ranch offers modern living with a fitness center and more. Enjoy a vibrant community with top amenities in San Antonio's Far West Side.",
      "page_copy": "Explore the ideal apartments for rent near me with fitness center at Ember @ Alamo Ranch, where convenience meets active living. Nestled in the rapidly growing Far West Side of San Antonio, this pet-friendly community provides a perfect blend of suburban tranquility and urban accessibility. With nearby top schools and military bases, it's a prime location for families and professionals.\n\nResidents can maintain an active lifestyle with access to a state-of-the-art fitness center, walking trails, and a pool. The community also features a clubhouse, dog park, and sundeck for relaxation and socializing. With modern amenities like controlled access, EV charging, and online services, Ember @ Alamo Ranch ensures a comfortable and secure living experience. Discover the best of San Antonio living with a fitness center and more at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in San Antonio's Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-dog-park-ember",
      "search_query": "Apartments For Rent Near Me with Dog Park",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Dog Park at Ember @ Alamo Ranch",
      "h2_subtitle": "Ember @ Alamo Ranch offers pet-friendly living with a dog park and more. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Explore the ideal apartments for rent near me with dog park at Ember @ Alamo Ranch, where pet-friendly living meets modern convenience. Situated in the rapidly expanding Far West Side of San Antonio, this community offers a perfect blend of suburban tranquility and urban accessibility. With nearby top schools and military bases, it's a prime location for families and professionals.\n\nResidents can enjoy a dedicated dog park for their furry friends, along with access to a pool, fitness center, and clubhouse. The community also features walking trails, a sundeck, and concierge services for added convenience. With modern amenities like controlled access, EV charging, and online services, Ember @ Alamo Ranch ensures a comfortable and secure living experience. Discover the best of San Antonio living with a dog park and more at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent Near Me with Dog Park",
      "seo_description": "Find apartments for rent near me with dog park at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in San Antonio's Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pet-play-area",
      "search_query": "Apartments For Rent Near Me with Pet Play Area",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pet Play Area at Ember @ Alamo Ranch",
      "h2_subtitle": "Ember @ Alamo Ranch offers pet-friendly living with a pet play area and more. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Discover the perfect apartments for rent near me with pet play area at Ember @ Alamo Ranch, where pet-friendly living is a priority. Located in the rapidly growing Far West Side of San Antonio, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for families and professionals.\n\nResidents can enjoy a dedicated pet play area for their furry companions, along with access to a pool, fitness center, and clubhouse. The community also features walking trails, a sundeck, and concierge services for added convenience. With modern amenities like controlled access, EV charging, and online services, Ember @ Alamo Ranch provides a secure and comfortable living environment. Experience the best of San Antonio living with a pet play area and more at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent Near Me with Pet Play Area",
      "seo_description": "Explore apartments for rent near me with pet play area at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in San Antonio's Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-san-antonio-tx-near-christus-hospital",
      "search_query": "Apartments For Rent In San Antonio TX Near CHRISTUS Santa Rosa Hospital - Westover Hills",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In San Antonio TX Near CHRISTUS Santa Rosa Hospital - Westover Hills",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near CHRISTUS Santa Rosa Hospital. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Discover the perfect apartments for rent in San Antonio TX near CHRISTUS Santa Rosa Hospital - Westover Hills at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for families and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to CHRISTUS Santa Rosa Hospital, Ember @ Alamo Ranch provides a convenient and comfortable living environment for healthcare professionals and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near CHRISTUS Santa Rosa Hospital - Westover Hills",
      "seo_description": "Explore apartments for rent in San Antonio TX near CHRISTUS Santa Rosa Hospital at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-san-antonio-tx-near-urology",
      "search_query": "Apartments For Rent In San Antonio TX Near Urology San Antonio (Westover Hills)",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In San Antonio TX Near Urology San Antonio (Westover Hills)",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near Urology San Antonio. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Explore the ideal apartments for rent in San Antonio TX near Urology San Antonio (Westover Hills) at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for families and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to Urology San Antonio, Ember @ Alamo Ranch provides a convenient and comfortable living environment for healthcare professionals and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near Urology San Antonio (Westover Hills)",
      "seo_description": "Explore apartments for rent in San Antonio TX near Urology San Antonio at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-san-antonio-tx-near-bhs",
      "search_query": "Apartments For Rent In San Antonio TX Near BHS Physician Network",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In San Antonio TX Near BHS Physician Network",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near BHS Physician Network. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Discover the perfect apartments for rent in San Antonio TX near BHS Physician Network at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for families and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to BHS Physician Network, Ember @ Alamo Ranch provides a convenient and comfortable living environment for healthcare professionals and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near BHS Physician Network",
      "seo_description": "Explore apartments for rent in San Antonio TX near BHS Physician Network at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-san-antonio-tx-near-conviva",
      "search_query": "Apartments For Rent In San Antonio TX Near Conviva Care Center",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In San Antonio TX Near Conviva Care Center",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near Conviva Care Center. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Explore the ideal apartments for rent in San Antonio TX near Conviva Care Center at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for families and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to Conviva Care Center, Ember @ Alamo Ranch provides a convenient and comfortable living environment for healthcare professionals and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near Conviva Care Center",
      "seo_description": "Explore apartments for rent in San Antonio TX near Conviva Care Center at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-san-antonio-tx-near-foundation-hospital",
      "search_query": "Apartments For Rent In San Antonio TX Near Foundation Surgical Hospital of San Antonio",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In San Antonio TX Near Foundation Surgical Hospital",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near Foundation Surgical Hospital. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Discover the perfect apartments for rent in San Antonio TX near Foundation Surgical Hospital of San Antonio at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for families and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to Foundation Surgical Hospital, Ember @ Alamo Ranch provides a convenient and comfortable living environment for healthcare professionals and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near Foundation Surgical Hospital",
      "seo_description": "Explore apartments for rent in San Antonio TX near Foundation Surgical Hospital at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-san-antonio-college",
      "search_query": "Apartments For Rent In San Antonio TX Near San Antonio College",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In San Antonio TX Near San Antonio College",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near San Antonio College. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Explore the ideal apartments for rent in San Antonio TX near San Antonio College at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for students and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to San Antonio College, Ember @ Alamo Ranch provides a convenient and comfortable living environment for students and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near San Antonio College",
      "seo_description": "Explore apartments for rent in San Antonio TX near San Antonio College at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-san-antonio-tx-near-st-marys-university",
      "search_query": "Apartments For Rent In San Antonio TX Near St. Mary's University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In San Antonio TX Near St. Mary's University",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near St. Mary's University. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Discover the perfect apartments for rent in San Antonio TX near St. Mary's University at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for students and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to St. Mary's University, Ember @ Alamo Ranch provides a convenient and comfortable living environment for students and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near St. Mary's University",
      "seo_description": "Explore apartments for rent in San Antonio TX near St. Mary's University at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-san-antonio-tx-near-northwest-vista-college",
      "search_query": "Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near Northwest Vista College. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Explore the ideal apartments for rent in San Antonio TX near Northwest Vista College at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for students and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to Northwest Vista College, Ember @ Alamo Ranch provides a convenient and comfortable living environment for students and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "seo_description": "Explore apartments for rent in San Antonio TX near Northwest Vista College at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-our-lady-lake-university-san-antonio",
      "search_query": "Apartments For Rent In San Antonio TX Near Our Lady of the Lake University",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In San Antonio TX Near Our Lady of the Lake University",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near Our Lady of the Lake University. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Discover the perfect apartments for rent in San Antonio TX near Our Lady of the Lake University at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for students and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to Our Lady of the Lake University, Ember @ Alamo Ranch provides a convenient and comfortable living environment for students and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near Our Lady of the Lake University",
      "seo_description": "Explore apartments for rent in San Antonio TX near Our Lady of the Lake University at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-san-antonio-tx-koehler-house",
      "search_query": "Apartments For Rent In San Antonio TX Near The Koehler House",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In San Antonio TX Near The Koehler House",
      "h2_subtitle": "Ember @ Alamo Ranch offers convenient living near The Koehler House. Enjoy modern amenities and a vibrant community in San Antonio's Far West Side.",
      "page_copy": "Explore the ideal apartments for rent in San Antonio TX near The Koehler House at Ember @ Alamo Ranch. Located in the rapidly growing Far West Side, this community offers a serene escape with easy access to urban conveniences. With top schools and military bases nearby, it's an ideal location for families and professionals.\n\nResidents enjoy a variety of amenities including a fitness center, pool, and clubhouse, along with walking and biking trails. Each apartment features modern conveniences like granite countertops, stainless steel appliances, and high-speed internet access. With its proximity to The Koehler House, Ember @ Alamo Ranch provides a convenient and comfortable living environment for history enthusiasts and families alike. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near The Koehler House",
      "seo_description": "Explore apartments for rent in San Antonio TX near The Koehler House at Ember @ Alamo Ranch. Enjoy top amenities and a vibrant community in the Far West Side.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-san-antonio-near-briscoe-middle",
      "search_query": "Apartments For Rent In San Antonio TX Near Dolph Briscoe Middle School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In San Antonio TX Near Dolph Briscoe Middle School",
      "h2_subtitle": "Ember @ Alamo Ranch offers family-friendly living just 4.0 km from Dolph Briscoe Middle School. Enjoy modern amenities and spacious floor plans in San Antonio's Far West Side.",
      "page_copy": "Explore the ideal apartments for rent in San Antonio TX near Dolph Briscoe Middle School at Ember @ Alamo Ranch. Located just 4.0 km away, this community is perfect for families seeking proximity to quality education. Situated in the rapidly growing Far West Side, Ember @ Alamo Ranch offers a serene escape with easy access to urban conveniences.\n\nFamilies can choose from spacious 1 and 2-bedroom floor plans, each featuring modern amenities like granite countertops, stainless steel appliances, and high-speed internet access. The community also offers a fitness center, pool, and clubhouse, along with walking and biking trails. With its close proximity to Dolph Briscoe Middle School, Ember @ Alamo Ranch provides a convenient and comfortable living environment for families. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near Dolph Briscoe Middle School",
      "seo_description": "Explore family-friendly apartments for rent in San Antonio TX near Dolph Briscoe Middle School at Ember @ Alamo Ranch. Enjoy top amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-san-antonio-near-john-hoffmann",
      "search_query": "Apartments For Rent In San Antonio TX Near John Hoffmann Elementary School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In San Antonio TX Near John Hoffmann Elementary School",
      "h2_subtitle": "Ember @ Alamo Ranch offers family-friendly living just 3.9 km from John Hoffmann Elementary School. Enjoy modern amenities and spacious floor plans in San Antonio's Far West Side.",
      "page_copy": "Discover the perfect apartments for rent in San Antonio TX near John Hoffmann Elementary School at Ember @ Alamo Ranch. Located just 3.9 km away, this community is ideal for families seeking proximity to quality education. Situated in the rapidly growing Far West Side, Ember @ Alamo Ranch offers a serene escape with easy access to urban conveniences.\n\nFamilies can choose from spacious 1 and 2-bedroom floor plans, each featuring modern amenities like granite countertops, stainless steel appliances, and high-speed internet access. The community also offers a fitness center, pool, and clubhouse, along with walking and biking trails. With its close proximity to John Hoffmann Elementary School, Ember @ Alamo Ranch provides a convenient and comfortable living environment for families. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near John Hoffmann Elementary School",
      "seo_description": "Explore family-friendly apartments for rent in San Antonio TX near John Hoffmann Elementary School at Ember @ Alamo Ranch. Enjoy top amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-san-antonio-tx-near-brennan-high",
      "search_query": "Apartments For Rent In San Antonio TX Near William J. Brennan High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In San Antonio TX Near William J. Brennan High School",
      "h2_subtitle": "Ember @ Alamo Ranch offers family-friendly living just 6.9 km from William J. Brennan High School. Enjoy modern amenities and spacious floor plans in San Antonio's Far West Side.",
      "page_copy": "Discover the perfect apartments for rent in San Antonio TX near William J. Brennan High School at Ember @ Alamo Ranch. Located just 6.9 km away, this community is ideal for families seeking proximity to quality education within the Northside Independent School District. Situated in the rapidly growing Far West Side, Ember @ Alamo Ranch offers a serene escape with easy access to urban conveniences.\n\nFamilies can choose from spacious 1 and 2-bedroom floor plans, each featuring modern amenities like granite countertops, stainless steel appliances, and high-speed internet access. The community also offers a fitness center, pool, and clubhouse, along with walking and biking trails. With its close proximity to William J. Brennan High School, Ember @ Alamo Ranch provides a convenient and comfortable living environment for families. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near William J. Brennan High School",
      "seo_description": "Explore family-friendly apartments for rent in San Antonio TX near William J. Brennan High School at Ember @ Alamo Ranch. Enjoy top amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5719836663480320",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-san-antonio-tx-near-taft-high-school",
      "search_query": "Apartments For Rent In San Antonio TX Near William H. Taft High School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In San Antonio TX Near William H. Taft High School",
      "h2_subtitle": "Ember @ Alamo Ranch offers family-friendly living just 1.2 km from William H. Taft High School. Enjoy modern amenities and spacious floor plans in San Antonio's Far West Side.",
      "page_copy": "Explore the ideal apartments for rent in San Antonio TX near William H. Taft High School at Ember @ Alamo Ranch. Located just 1.2 km away, this community is perfect for families seeking proximity to quality education within the Northside Independent School District. Situated in the rapidly growing Far West Side, Ember @ Alamo Ranch offers a serene escape with easy access to urban conveniences.\n\nFamilies can choose from spacious 1 and 2-bedroom floor plans, each featuring modern amenities like granite countertops, stainless steel appliances, and high-speed internet access. The community also offers a fitness center, pool, and clubhouse, along with walking and biking trails. With its close proximity to William H. Taft High School, Ember @ Alamo Ranch provides a convenient and comfortable living environment for families. Experience the best of San Antonio living at Ember @ Alamo Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies.",
        "public_id": "019f6c0e-9760-74fb-998f-4aa45037f49b",
        "storage_key": "property/5719836663480320/019f6c0e-9760-74fb-998f-4aa45037f49b.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a building with a pool and lounge chairs.",
        "public_id": "019f6c0e-a0b1-7758-9f44-cc4541364812",
        "storage_key": "property/5719836663480320/019f6c0e-a0b1-7758-9f44-cc4541364812.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Ember @ Alamo Ranch | Apartments For Rent In San Antonio TX Near William H. Taft High School",
      "seo_description": "Explore family-friendly apartments for rent in San Antonio TX near William H. Taft High School at Ember @ Alamo Ranch. Enjoy top amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2281"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505043885"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4981186"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TGF39LB"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443881655"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "c094cbc2711f1865"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/gow3mq1qv2m"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/62ecd72d-fa23-4be6-8b29-cf83029a758b"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "361-320-7613"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImRQRGE3SmFMaDVYeFhyMGkxSkRITlE9PSIsInZhbHVlIjoidlNCY1BuMTdwbEQwc0VranJGYWlUQT09IiwibWFjIjoiNThkZDBmMmI0MTczN2VjYjBkM2IzZjQ4OTk3MmU1MTk5NTdiMzNlOGM5ZjQxYjhhYjk2YjEzMjIzZTYwNzFmMyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2281",
  "custom_repli_id": "2505043885",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4981186",
  "custom_google_gtm_id": "GTM-TGF39LB",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443881655",
  "custom_knock_community_id": "c094cbc2711f1865",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/gow3mq1qv2m",
  "custom_self_guided_tour_url": "https://selftournow.com/property/62ecd72d-fa23-4be6-8b29-cf83029a758b",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "361-320-7613",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImRQRGE3SmFMaDVYeFhyMGkxSkRITlE9PSIsInZhbHVlIjoidlNCY1BuMTdwbEQwc0VranJGYWlUQT09IiwibWFjIjoiNThkZDBmMmI0MTczN2VjYjBkM2IzZjQ4OTk3MmU1MTk5NTdiMzNlOGM5ZjQxYjhhYjk2YjEzMjIzZTYwNzFmMyJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "48184884-7f94-436b-8aff-24b698292902",
  "custom_audioeye_site_hash": "34031d43f47ec448c5fb7d70b4291b2b"
};

export const generatedAt = '2026-11-03T20:36:03.358Z';
